// Customizer const
export const TOGGLE_COLLAPSED_NAV = 'toggle_collapse_menu';
export const DRAWER_TYPE = 'drawer_type';
export const FIXED_DRAWER = 'fixed_drawer';
export const COLLAPSED_DRAWER = 'collapsible';
export const MINI_DRAWER = 'mini_drawer';
export const THEME_COLOR = 'theme_color';
export const DARK_THEME = 'dark_theme';
export const WINDOW_WIDTH = 'window-width';
export const SWITCH_LANGUAGE = 'switch-language';
export const CHANGE_DIRECTION = 'change-direction';

export const CHANGE_NAVIGATION_STYLE = 'change-navigation-style';
export const HORIZONTAL_NAVIGATION = 'horizontal_navigation';
export const VERTICAL_NAVIGATION = 'vertical_navigation';

export const HORIZONTAL_MENU_POSITION = 'horizontal_menu_position';
export const ABOVE_THE_HEADER = 'above_the_header';
export const INSIDE_THE_HEADER = 'inside_the_header';
export const BELOW_THE_HEADER = 'below_the_header';

//Contact Module const

export const FETCH_START = 'fetch_start';
export const FETCH_SUCCESS = 'fetch_success';
export const FETCH_ERROR = 'fetch_error';
export const SHOW_MESSAGE = 'show_message';
export const SHOW_MESSAGE_SUCCESS = 'show_message_success';
export const SHOW_MESSAGE_ERROR = 'show_message_error';
export const HIDE_MESSAGE = 'hide_message';

//Auth const
export const SIGNIN_USER = 'signin_user';
export const SIGNIN_USER_SUCCESS = 'signin_user_success';
export const SIGNOUT_USER = 'signout_user';
export const SIGNOUT_USER_SUCCESS = 'signout_user_success';
export const INIT_URL = 'init_url';
export const USER_TOKEN_SET = 'user_token_set';

// Chat Module const

export const ON_SHOW_LOADER = 'on_show_loader';
export const ON_HIDE_LOADER = 'on_hide_loader';
export const ON_SHOW_SUCCESS_MESSAGE = 'on_show_success_message';

// Padrao Fluxo
export const APLICA_FILTRO = 'aplica_filtro';
export const APLICA_FILTRO_ALUNO = 'aplica_filtro_aluno';
export const APLICA_FILTRO_SERIE = 'aplica_filtro_serie';
export const APLICA_FILTRO_CURSO = 'aplica_filtro_curso';
export const APLICA_FILTRO_ESCOLA = 'aplica_filtro_escola';
export const APLICA_FILTRO_TURMA = 'aplica_filtro_turma';
export const APLICA_FILTRO_DISCIPLINA = 'aplica_filtro_disciplina';
export const APLICA_FILTRO_SERIE_ESCOLA = 'aplica_filtro_serie_escola';
export const APLICA_FILTRO_REGRA_AVALIACAO = 'aplica_filtro_regra_avaliacao';
export const APLICA_FILTRO_ANO_LETIVO = 'aplica_filtro_ano_letivo';
export const APLICA_FILTRO_SEQUENCIA_ENTURMACAO = 'aplica_filtro_sequencia_enturmacao';
export const APLICA_FILTRO_COMPANY = 'aplica_filtro_company';
export const APLICA_FILTRO_CLIENTE_ALTERNAR = 'aplica_filtro_cliente_alternar';
export const ALTERNA_CLIENTE = 'alterna_cliente';
export const ALTERNA_CLIENTE_SUCESSO = 'alterna_cliente_sucesso';
export const FECHA_DRAWER_ALTERNACAO = 'fecha_drawer_alternacao';
export const ABORTA_OPERACAO = 'aborta_operacao';
export const CONSULTA_CPF = 'consulta_cpf';
export const CONSULTA_CPF_SUCESSO = 'consulta_cpf_sucesso';
export const CANCELA_EDICAO = 'cancela_edicao';
export const ON_SHOW_ERROR_MESSAGE = 'on_show_error_message';
export const ALTERACAO_CAMPO = 'alteracao_campo';
export const ALTERACAO_COMBO = 'alteracao_combo';
export const ALTERACAO_COMBO_INICIO = 'alteracao_combo_inicio';
export const ALTERACAO_DATEPICKER = 'alteracao_datepicker';
export const CLIQUE_CONTROLE_ABA_LOCAL = 'clique_controle_aba_local';
export const ALTERACAO_CHECK = 'alteracao_check';
export const ALTERACAO_CHECK_USUARIO = 'alteracao_check_usuario';
export const ALTERACAO_CAMPO_MASCARA_CPF = 'alteracao_campo_mascara_cpf';
export const ALTERACAO_CAMPO_MASCARA_CNPJ = 'alteracao_campo_mascara_cnpj';
export const ALTERACAO_CAMPO_MASCARA_TELEFONE = 'alteracao_campo_mascara_telefone';
export const ALTERACAO_CAMPO_MASCARA_TELEFONE_2 = 'alteracao_campo_mascara_telefone_2';
export const ALTERACAO_CAMPO_MASCARA_IP = 'alteracao_campo_mascara_ip';
export const ALTERACAO_CAMPO_MASCARA_CEP = 'alteracao_campo_mascara_cep';
export const ALTERACAO_CAMPO_MASCARA_DATE = 'alteracao_campo_mascara_date';
export const ALTERACAO_CHECK_PONTO_ACESSO = 'alteracao_check_ponto_acesso';
export const SALVAR_CLIENTE_EM_USO = 'salvar_cliente_em_uso';
export const ALTERAR_CLIENTE_EM_USO = 'alterar_cliente_em_uso';
export const INICIA_DEFINICOES = 'inicia_definicoes';
export const INICIO_DEFINICOES_SUCESSO = 'inicio_definicoes_sucesso';
export const INICIA_RELATORIO_ACESSO = 'inicia_relatorio_acesso';
export const INICIO_RELATORIO_ACESSO_SUCESSO = 'inicio_relatorio_acesso_sucesso';
export const INICIA_RELATORIO_PESSOAS_UNIDADE = 'inicia_relatorio_pessoas_unidade';
export const INICIA_RELATORIO_PESSOAS_UNIDADE_SUCESSO = 'inicia_relatorio_pessoas_unidade_sucesso';
export const GERA_RELATORIO_ACESSO = 'gera_relatorio_acesso';
export const GERA_RELATORIO_ACESSO_SUCESSO = 'gera_relatorio_acesso_sucesso';
export const GERA_RELATORIO_PESSOAS_UNIDADE = 'gera_relatorio_pessoas_unidade';
export const GERA_RELATORIO_PESSOAS_UNIDADEO_SUCESSO = 'gera_relatorio_pessoas_unidade_sucesso';
export const TOKEN_INVALIDO = 'token_invalido';
export const VALIDACAO_CAMPO = 'validacao_campo';
export const LIMPA_VALIDACOES = 'limpa_validacoes';
export const FECHA_MODULOS = 'fecha_modulos';
export const SELECIONA_MODULOS = 'seleciona_modulos';
export const INICIA_CARREGAMENTO_CONFIGURACAO = 'inicia_carregamento_configuracao';
export const ATIVA_TESTES = 'ativa_testes';
export const DESATIVA_TIMER = 'desativa_timer';
export const ATUALIZA_DATA_PESQUISA_LIBERACAO = 'atualiza_data_pesquisa_liberacao';
export const LIMPA_PESQUISA_LIBERACAO = 'limpa_pesquisa_liberacao';
export const ALTERACAO_CAMPO_PESQUISA_PESSOA_TESTE = 'alteracao_campo_pesquisa_pessoa_teste';
export const ALTERACAO_CAMPO_PESQUISA_UNIDADE_GARAGEM = 'alteracao_campo_pesquisa_unidade_garagem';
export const APLICAR_FILTRO_SUCESSO = 'aplicar_filtro_sucesso';

// Modelos de equipamentos
export const INICIA_MODELO = 'inicia_modelo';
export const SALVA_MODELO = 'salva_modelo';
export const REMOVE_MODELO = 'remove_modelo';

// Series Escola
export const GET_SERIES_ESCOLA = 'get_series_escola';
export const GET_SERIES_ESCOLA_SUCCESS = 'get_series_escola_success';
export const ADD_SERIES_ESCOLA = 'add_series_escola';
export const ADD_SERIES_ESCOLA_SUCCESS = 'add_series_escola_success';
export const UPDATE_SERIES_ESCOLA = 'update_series_escola';
export const UPDATE_SERIES_ESCOLA_SUCCESS = 'update_series_escola_success';
export const DELETE_SERIES_ESCOLA = 'delete_series_escola';
export const DELETE_SERIES_ESCOLA_SUCCESS = 'delete_series_escola_success';
export const LISTA_CURSOS_POR_ESCOLA_SERIES_ESCOLA = 'lista_cursos_por_escola_series_escola';
export const LISTA_CURSOS_POR_ESCOLA_SERIES_ESCOLA_SUCESSO = 'lista_cursos_por_escola_series_escola_sucesso';
export const LISTA_SERIES_POR_CURSO_SERIES_ESCOLA = 'lista_series_por_curso_series_escola';
export const LISTA_SERIES_POR_CURSO_SERIES_ESCOLA_SUCESSO = 'lista_series_por_curso_series_escola_sucesso';
export const LISTA_ANOS_LETIVOS_POR_CURSO_SERIES_ESCOLA = 'lista_anos_letivos_por_curso_series_escola';
export const LISTA_ANOS_LETIVOS_POR_CURSO_SERIES_ESCOLA_SUCESSO = 'lista_anos_letivos_por_curso_series_escola_sucesso';
export const BUSCA_SERIES_ESCOLA_EDICAO = 'busca_series_escola_edicao';
export const BUSCA_SERIES_ESCOLA_EDICAO_SUCESSO = 'busca_series_escola_edicao_sucesso';

// Componentes da Série
export const GET_COMPONENTES_SERIE = 'get_componentes_serie';
export const GET_COMPONENTES_SERIE_SUCCESS = 'get_componentes_serie_success';
export const SAVE_COMPONENTES_SERIE = 'save_componentes_serie';
export const SAVE_COMPONENTES_SERIE_SUCCESS = 'save_componentes_serie_success';
export const GET_DISCIPLINAS_POR_AREA = 'get_disciplinas_por_area';
export const GET_DISCIPLINAS_POR_AREA_SUCCESS = 'get_disciplinas_por_area_success';

// Areas Conhecimento
export const LISTA_AREAS_CONHECIMENTO = 'lista_areas_conhecimento';
export const LISTA_AREAS_CONHECIMENTO_SUCESSO = 'lista_areas_conhecimento_sucesso';

export const NOVO_SERIES_ESCOLA = 'novo_series_escola';
export const NOVO_MODELO = 'novo_modelo';
export const BUSCA_MODELO_EDICAO = 'busca_modelo_edicao';
export const INICIO_MODELO_SUCESSO = 'inicio_modelo_sucesso';
export const SALVA_MODELO_SUCESSO = 'salva_modelo_success';
export const REMOVE_MODELO_SUCESSO = 'remove_modelo_success';
export const BUSCA_MODELO_EDICAO_SUCESSO = 'busca_modelo_edicao_sucesso';
export const LISTA_MODELO_SUCESSO = 'lista_modelo_sucesso';
export const LIMPAR_MODELO = 'limpar_modelo';
export const LISTA_MODELO = 'lista_modelo';

// Equipamentos
export const INICIA_EQUIPAMENTO = 'inicia_equipamento';
export const SALVA_EQUIPAMENTO = 'salva_equipamento';
export const REMOVE_EQUIPAMENTO = 'remove_equipamento';
export const NOVO_EQUIPAMENTO = 'novo_equipamento';
export const BUSCA_EQUIPAMENTO_EDICAO = 'busca_equipamento_edicao';
export const INICIO_EQUIPAMENTO_SUCESSO = 'inicio_equipamento_sucesso';
export const SALVA_EQUIPAMENTO_SUCESSO = 'salva_equipamento_success';
export const REMOVE_EQUIPAMENTO_SUCESSO = 'remove_equipamento_success';
export const BUSCA_EQUIPAMENTO_EDICAO_SUCESSO = 'busca_equipamento_edicao_sucesso';
export const LISTA_EQUIPAMENTO_SUCESSO = 'lista_equipamento_sucesso';
export const LIMPAR_EQUIPAMENTO = 'limpar_equipamento';
export const LISTA_EQUIPAMENTO = 'lista_equipamento';

// Escolas
export const INICIA_ESCOLA = 'inicia_escola';
export const SALVA_ESCOLA = 'salva_escola';
export const ATUALIZA_ESCOLA = 'atualiza_escola';
export const REMOVE_ESCOLA = 'remove_escola';
export const NOVO_ESCOLA = 'novo_escola';
export const BUSCA_ESCOLA_EDICAO = 'busca_escola_edicao';
export const INICIO_ESCOLA_SUCESSO = 'inicio_escola_sucesso';
export const SALVA_ESCOLA_SUCESSO = 'salva_escola_success';
export const REMOVE_ESCOLA_SUCESSO = 'remove_escola_success';
export const BUSCA_ESCOLA_EDICAO_SUCESSO = 'busca_escola_edicao_sucesso';
export const LISTA_ESCOLA_SUCESSO = 'lista_escola_sucesso';
export const LIMPAR_ESCOLA = 'limpar_escola';
export const LISTA_ESCOLA = 'lista_escola';
export const ADICIONA_ESCOLA_CURSO = 'adiciona_escola_curso';
export const REMOVE_ESCOLA_CURSO = 'remove_escola_curso';
export const ALTERA_ESCOLA_CURSO = 'altera_escola_curso';
export const LISTA_CURSOS_ESCOLA_SUCESSO = 'lista_cursos_escola_sucesso';
export const LISTA_ANOS_LETIVOS_POR_ESCOLA = 'lista_anos_letivos_por_escola';
export const LISTA_ANOS_LETIVOS_POR_ESCOLA_SUCESSO = 'lista_anos_letivos_por_escola_sucesso';

// Alunos
export const INICIA_ALUNO = 'inicia_aluno';
export const SALVA_ALUNO = 'salva_aluno';
export const ATUALIZA_ALUNO = 'atualiza_aluno';
export const REMOVE_ALUNO = 'remove_aluno';
export const NOVO_ALUNO = 'novo_aluno';
export const BUSCA_ALUNO_EDICAO = 'busca_aluno_edicao';
export const INICIO_ALUNO_SUCESSO = 'inicio_aluno_sucesso';
export const SALVA_ALUNO_SUCESSO = 'salva_aluno_success';
export const REMOVE_ALUNO_SUCESSO = 'remove_aluno_success';
export const BUSCA_ALUNO_EDICAO_SUCESSO = 'busca_aluno_edicao_sucesso';
export const LISTA_ALUNO_SUCESSO = 'lista_aluno_sucesso';
export const LIMPAR_ALUNO = 'limpar_aluno';
export const LISTA_ALUNO = 'lista_aluno';
export const LISTA_ESCOLAS_ALUNO = 'lista_escolas_aluno';
export const LISTA_ESCOLAS_ALUNO_SUCESSO = 'lista_escolas_aluno_sucesso';
export const LISTA_CURSOS_POR_ESCOLA_ALUNO = 'lista_cursos_por_escola_aluno';
export const LISTA_CURSOS_POR_ESCOLA_ALUNO_SUCESSO = 'lista_cursos_por_escola_aluno_sucesso';
export const LISTA_SERIES_POR_CURSO_ALUNO = 'lista_series_por_curso_aluno';
export const LISTA_SERIES_POR_CURSO_ALUNO_SUCESSO = 'lista_series_por_curso_aluno_sucesso';
export const LISTA_TURMAS_POR_SERIE_ALUNO = 'lista_turmas_por_serie_aluno';
export const LISTA_TURMAS_POR_SERIE_ALUNO_SUCESSO = 'lista_turmas_por_serie_aluno_sucesso';

// Cursos
export const INICIA_CURSO = 'inicia_curso';
export const SALVA_CURSO = 'salva_curso';
export const ATUALIZA_CURSO = 'atualiza_curso';
export const REMOVE_CURSO = 'remove_curso';
export const NOVO_CURSO = 'novo_curso';
export const BUSCA_CURSO_EDICAO = 'busca_curso_edicao';
export const INICIO_CURSO_SUCESSO = 'inicio_curso_sucesso';
export const SALVA_CURSO_SUCESSO = 'salva_curso_success';
export const REMOVE_CURSO_SUCESSO = 'remove_curso_success';
export const BUSCA_CURSO_EDICAO_SUCESSO = 'busca_curso_edicao_sucesso';
export const LISTA_CURSO_SUCESSO = 'lista_curso_sucesso';
export const LIMPAR_CURSO = 'limpar_curso';
export const LISTA_CURSO = 'lista_curso';
export const LISTA_ESCOLAS_CURSO = 'lista_escolas_curso';
export const LISTA_ESCOLAS_CURSO_SUCESSO = 'lista_escolas_curso_sucesso';
export const LISTA_ANOS_LETIVOS_POR_ESCOLA_CURSO = 'lista_anos_letivos_por_escola_curso';
export const LISTA_ANOS_LETIVOS_POR_ESCOLA_CURSO_SUCESSO = 'lista_anos_letivos_por_escola_curso_sucesso';
export const LISTA_CURSOS_POR_ESCOLA = 'lista_cursos_por_escola';
export const LISTA_CURSOS_POR_ESCOLA_SUCESSO = 'lista_cursos_por_escola_sucesso';
export const LISTA_ANOS_LETIVOS_POR_CURSO = 'lista_anos_letivos_por_curso';
export const LISTA_ANOS_LETIVOS_POR_CURSO_SUCESSO = 'lista_anos_letivos_por_curso_sucesso';

// Séries
export const INICIA_SERIE = 'inicia_serie';
export const SALVA_SERIE = 'salva_serie';
export const ATUALIZA_SERIE = 'atualiza_serie';
export const REMOVE_SERIE = 'remove_serie';
export const NOVO_SERIE = 'novo_serie';
export const BUSCA_SERIE_EDICAO = 'busca_serie_edicao';
export const INICIO_SERIE_SUCESSO = 'inicio_serie_sucesso';
export const SALVA_SERIE_SUCESSO = 'salva_serie_success';
export const REMOVE_SERIE_SUCESSO = 'remove_serie_success';
export const BUSCA_SERIE_EDICAO_SUCESSO = 'busca_serie_edicao_sucesso';
export const LISTA_SERIE_SUCESSO = 'lista_serie_sucesso';
export const LIMPAR_SERIE = 'limpar_serie';
export const LISTA_SERIE = 'lista_serie';
// Séries - combos dependentes
export const LISTA_ESCOLAS_SERIE = 'lista_escolas_serie';
export const LISTA_ESCOLAS_SERIE_SUCESSO = 'lista_escolas_serie_sucesso';
export const LISTA_CURSOS_POR_ESCOLA_SERIE = 'lista_cursos_por_escola_serie';
export const LISTA_CURSOS_POR_ESCOLA_SERIE_SUCESSO = 'lista_cursos_por_escola_serie_sucesso';


// Turmas
export const INICIA_TURMA = 'inicia_turma';
export const SALVA_TURMA = 'salva_turma';
export const ATUALIZA_TURMA = 'atualiza_turma';
export const REMOVE_TURMA = 'remove_turma';
export const NOVO_TURMA = 'novo_turma';
export const BUSCA_TURMA_EDICAO = 'busca_turma_edicao';
export const INICIO_TURMA_SUCESSO = 'inicio_turma_sucesso';
export const SALVA_TURMA_SUCESSO = 'salva_turma_success';
export const REMOVE_TURMA_SUCESSO = 'remove_turma_success';
export const BUSCA_TURMA_EDICAO_SUCESSO = 'busca_turma_edicao_sucesso';
export const LISTA_TURMA_SUCESSO = 'lista_turma_sucesso';
export const LIMPAR_TURMA = 'limpar_turma';
export const LISTA_TURMA = 'lista_turma';
// Turmas - combos dependentes
export const LISTA_ESCOLAS_TURMA = 'lista_escolas_turma';
export const LISTA_ESCOLAS_TURMA_SUCESSO = 'lista_escolas_turma_sucesso';
export const LISTA_CURSOS_POR_ESCOLA_TURMA = 'lista_cursos_por_escola_turma';
export const LISTA_CURSOS_POR_ESCOLA_TURMA_SUCESSO = 'lista_cursos_por_escola_turma_sucesso';
export const LISTA_SERIES_POR_CURSO_TURMA = 'lista_series_por_curso_turma';
export const LISTA_SERIES_POR_CURSO_TURMA_SUCESSO = 'lista_series_por_curso_turma_sucesso';
export const LISTA_ANOS_LETIVOS_POR_ESCOLA_TURMA = 'lista_anos_letivos_por_escola_turma';
export const LISTA_ANOS_LETIVOS_POR_ESCOLA_TURMA_SUCESSO = 'lista_anos_letivos_por_escola_turma_sucesso';
// Disciplinas disponíveis para a turma
export const GET_DISCIPLINAS_TURMA = 'get_disciplinas_turma';
export const GET_DISCIPLINAS_TURMA_SUCCESS = 'get_disciplinas_turma_success';
// Tipos de Turma
export const LISTA_TIPOS_TURMA = 'lista_tipos_turma';
export const LISTA_TIPOS_TURMA_SUCESSO = 'lista_tipos_turma_sucesso';
export const SALVA_TIPO_TURMA = 'salva_tipo_turma';
export const ATUALIZA_TIPO_TURMA = 'atualiza_tipo_turma';
export const REMOVE_TIPO_TURMA = 'remove_tipo_turma';

// Ano Letivo - Microgerência Tipo de Etapa (modal)
export const ANOLETIVO_TIPOETAPA_MODAL_OPEN = 'anoletivo_tipoetapa_modal_open';
export const ANOLETIVO_TIPOETAPA_MODAL_CLOSE = 'anoletivo_tipoetapa_modal_close';
export const ANOLETIVO_TIPOETAPA_MODAL_ATUALIZA_CAMPO = 'anoletivo_tipoetapa_modal_atualiza_campo';
export const ANOLETIVO_TIPOETAPA_SALVAR = 'anoletivo_tipoetapa_salvar';
export const ANOLETIVO_TIPOETAPA_ATUALIZAR = 'anoletivo_tipoetapa_atualizar';
export const ANOLETIVO_TIPOETAPA_SALVAR_SUCESSO = 'anoletivo_tipoetapa_salvar_sucesso';
export const ANOLETIVO_TIPOETAPA_ATUALIZAR_SUCESSO = 'anoletivo_tipoetapa_atualizar_sucesso';

// Matrículas
export const INICIA_MATRICULA = 'inicia_matricula';
export const SALVA_MATRICULA = 'salva_matricula';
export const ATUALIZA_MATRICULA = 'atualiza_matricula';
export const REMOVE_MATRICULA = 'remove_matricula';
export const OCORRENCIAS_DISCIPLINARES_MATRICULA = 'ocorrencias_disciplinares_matricula';
export const DISPENSA_COMPONENTES_MATRICULA = 'dispensa_componentes_matricula';
export const DEIXOU_FREQUENTAR_MATRICULA = 'deixou_frequentar_matricula';
export const FALECIDO_MATRICULA = 'falecido_matricula';
export const RECLASSIFICAR_MATRICULA = 'reclassificar_matricula';
export const SOLICITAR_TRANSFERENCIA_MATRICULA = 'solicitar_transferencia_matricula';
export const MATRICULA_FALECIDO_MODAL_OPEN = 'matricula_falecido_modal_open';
export const MATRICULA_FALECIDO_MODAL_CLOSE = 'matricula_falecido_modal_close';
export const MATRICULA_FALECIDO_SALVAR = 'matricula_falecido_salvar';
export const MATRICULA_FALECIDO_MODAL_ATUALIZA_CAMPO = 'matricula_falecido_modal_atualiza_campo';
export const MATRICULA_FALECIDO_CANCELAR = 'matricula_falecido_cancelar';
// Matrículas - Deixou de Frequentar (modal)
export const MATRICULA_DEIXOU_MODAL_OPEN = 'matricula_deixou_modal_open';
export const MATRICULA_DEIXOU_MODAL_CLOSE = 'matricula_deixou_modal_close';
export const MATRICULA_DEIXOU_MODAL_ATUALIZA_CAMPO = 'matricula_deixou_modal_atualiza_campo';
export const MATRICULA_DEIXOU_SALVAR = 'matricula_deixou_salvar';
export const MATRICULA_DEIXOU_CANCELAR = 'matricula_deixou_cancelar';
export const MATRICULA_RECLASSIFICACAO_MODAL_OPEN = 'matricula_reclassificacao_modal_open';
export const MATRICULA_RECLASSIFICACAO_MODAL_CLOSE = 'matricula_reclassificacao_modal_close';
export const MATRICULA_RECLASSIFICACAO_MODAL_ATUALIZA_CAMPO = 'matricula_reclassificacao_modal_atualiza_campo';
export const MATRICULA_RECLASSIFICACAO_SALVAR = 'matricula_reclassificacao_salvar';
export const MATRICULA_RECLASSIFICACAO_CANCELAR = 'matricula_reclassificacao_cancelar';
export const MATRICULA_TRANSFERENCIA_MODAL_OPEN = 'matricula_transferencia_modal_open';
export const MATRICULA_TRANSFERENCIA_MODAL_CLOSE = 'matricula_transferencia_modal_close';
export const MATRICULA_TRANSFERENCIA_MODAL_ATUALIZA_CAMPO = 'matricula_transferencia_modal_atualiza_campo';
export const MATRICULA_TRANSFERENCIA_SALVAR = 'matricula_transferencia_salvar';
export const MATRICULA_TRANSFERENCIA_CANCELAR = 'matricula_transferencia_cancelar';
export const MATRICULA_TRANSFERENCIA_VISUALIZAR = 'matricula_transferencia_visualizar';
export const NOVO_MATRICULA = 'novo_matricula';
export const BUSCA_MATRICULA_EDICAO = 'busca_matricula_edicao';
export const INICIO_MATRICULA_SUCESSO = 'inicio_matricula_sucesso';
export const SALVA_MATRICULA_SUCESSO = 'salva_matricula_success';
export const REMOVE_MATRICULA_SUCESSO = 'remove_matricula_success';
export const BUSCA_MATRICULA_EDICAO_SUCESSO = 'busca_matricula_edicao_sucesso';
export const LISTA_MATRICULA_SUCESSO = 'lista_matricula_sucesso';
export const LIMPAR_MATRICULA = 'limpar_matricula';
export const LISTA_MATRICULA = 'lista_matricula';
// Matrículas - combos dependentes
export const LISTA_ESCOLAS_MATRICULA = 'lista_escolas_matricula';
export const LISTA_ESCOLAS_MATRICULA_SUCESSO = 'lista_escolas_matricula_sucesso';
export const LISTA_CURSOS_POR_ESCOLA_MATRICULA = 'lista_cursos_por_escola_matricula';
export const LISTA_CURSOS_POR_ESCOLA_MATRICULA_SUCESSO = 'lista_cursos_por_escola_matricula_sucesso';
export const LISTA_SERIES_POR_CURSO_MATRICULA = 'lista_series_por_curso_matricula';
export const LISTA_SERIES_POR_CURSO_MATRICULA_SUCESSO = 'lista_series_por_curso_matricula_sucesso';
export const LISTA_TURMAS_POR_SERIE_MATRICULA = 'lista_turmas_por_serie_matricula';
export const LISTA_TURMAS_POR_SERIE_MATRICULA_SUCESSO = 'lista_turmas_por_serie_matricula_sucesso';
export const LISTA_ALUNOS_MATRICULA = 'lista_alunos_matricula';
export const LISTA_ALUNOS_MATRICULA_SUCESSO = 'lista_alunos_matricula_sucesso';
export const LISTA_ANOS_LETIVOS_POR_ESCOLA_MATRICULA = 'lista_anos_letivos_por_escola_matricula';
export const LISTA_ANOS_LETIVOS_POR_ESCOLA_MATRICULA_SUCESSO = 'lista_anos_letivos_por_escola_matricula_sucesso';
// Matrículas - ocorrências disciplinares
export const MATRICULA_OCORRENCIA_MODAL_OPEN = 'matricula_ocorrencia_modal_open';
export const MATRICULA_OCORRENCIA_MODAL_CLOSE = 'matricula_ocorrencia_modal_close';
export const LISTA_MATRICULA_OCORRENCIAS = 'lista_matricula_ocorrencias';
export const LISTA_MATRICULA_OCORRENCIAS_SUCESSO = 'lista_matricula_ocorrencias_sucesso';
export const SALVA_MATRICULA_OCORRENCIA = 'salva_matricula_ocorrencia';
export const SALVA_MATRICULA_OCORRENCIA_SUCESSO = 'salva_matricula_ocorrencia_sucesso';
export const REMOVE_MATRICULA_OCORRENCIA = 'remove_matricula_ocorrencia';
export const REMOVE_MATRICULA_OCORRENCIA_SUCESSO = 'remove_matricula_ocorrencia_sucesso';
export const LISTA_TIPOS_OCORRENCIA_SUCESSO = 'lista_tipos_ocorrencia_sucesso';
// Ocorrências disciplinares - tipos (CRUD)
export const SALVA_TIPO_OCORRENCIA_DISCIPLINAR = 'salva_tipo_ocorrencia_disciplinar';
export const ATUALIZA_TIPO_OCORRENCIA_DISCIPLINAR = 'atualiza_tipo_ocorrencia_disciplinar';
// Disciplinas
export const INICIA_DISCIPLINA = 'inicia_disciplina';
export const SALVA_DISCIPLINA = 'salva_disciplina';
export const ATUALIZA_DISCIPLINA = 'atualiza_disciplina';
export const REMOVE_DISCIPLINA = 'remove_disciplina';
export const NOVO_DISCIPLINA = 'novo_disciplina';
export const BUSCA_DISCIPLINA_EDICAO = 'busca_disciplina_edicao';
export const INICIO_DISCIPLINA_SUCESSO = 'inicio_disciplina_sucesso';
export const SALVA_DISCIPLINA_SUCESSO = 'salva_disciplina_success';
export const REMOVE_DISCIPLINA_SUCESSO = 'remove_disciplina_success';
export const BUSCA_DISCIPLINA_EDICAO_SUCESSO = 'busca_disciplina_edicao_sucesso';
export const LISTA_DISCIPLINA_SUCESSO = 'lista_disciplina_sucesso';
export const LIMPAR_DISCIPLINA = 'limpar_disciplina';
export const LISTA_DISCIPLINA = 'lista_disciplina';

export const INICIA_ANO_LETIVO = 'inicia_ano_letivo';
export const SALVA_ANO_LETIVO = 'salva_ano_letivo';
export const ATUALIZA_ANO_LETIVO = 'atualiza_ano_letivo';
export const REMOVE_ANO_LETIVO = 'remove_ano_letivo';
export const NOVO_ANO_LETIVO = 'novo_ano_letivo';
export const BUSCA_ANO_LETIVO_EDICAO = 'busca_ano_letivo_edicao';
export const INICIO_ANO_LETIVO_SUCESSO = 'inicio_ano_letivo_sucesso';
export const SALVA_ANO_LETIVO_SUCESSO = 'salva_ano_letivo_success';
export const REMOVE_ANO_LETIVO_SUCESSO = 'remove_ano_letivo_success';
export const BUSCA_ANO_LETIVO_EDICAO_SUCESSO = 'busca_ano_letivo_edicao_sucesso';
export const LISTA_ANO_LETIVO_SUCESSO = 'lista_ano_letivo_sucesso';
export const LIMPAR_ANO_LETIVO = 'limpar_ano_letivo';
export const LISTA_ANO_LETIVO = 'lista_ano_letivo';
export const LISTA_TIPOS_ETAPAS_ANO_LETIVO = 'lista_tipos_etapas_ano_letivo';
export const LISTA_TIPOS_ETAPAS_ANO_LETIVO_SUCESSO = 'lista_tipos_etapas_ano_letivo_sucesso';
export const LISTA_ESCOLAS_ANO_LETIVO = 'lista_escolas_ano_letivo';
export const LISTA_ESCOLAS_ANO_LETIVO_SUCESSO = 'lista_escolas_ano_letivo_sucesso';

// Unidades
export const INICIA_UNIDADE = 'inicia_unidade';
export const SALVA_UNIDADE = 'salva_unidade';
export const REMOVE_UNIDADE = 'remove_unidade';
export const NOVO_UNIDADE = 'novo_unidade';
export const BUSCA_UNIDADE_EDICAO = 'busca_unidade_edicao';
export const INICIO_UNIDADE_SUCESSO = 'inicio_unidade_sucesso';
export const SALVA_UNIDADE_SUCESSO = 'salva_unidade_success';
export const REMOVE_UNIDADE_SUCESSO = 'remove_unidade_success';
export const BUSCA_UNIDADE_EDICAO_SUCESSO = 'busca_unidade_edicao_sucesso';
export const LISTA_UNIDADE_SUCESSO = 'lista_unidade_sucesso';
export const LIMPAR_UNIDADE = 'limpar_unidade';
export const LISTA_UNIDADE = 'lista_unidade';
export const INICIO_CENARIO_UNIDADE_LOCAL = 'inicio_cenario_unidade_local';
export const INICIO_CENARIO_UNIDADE_LOCAL_SUCESSO = 'inicio_cenario_unidade_sucesso';
export const NOVO_ESCANINHO = 'novo_escaninho';
export const ATUALIZA_ESCANINHO = 'atualiza_escaninho';
export const REMOVE_ESCANINHO = 'remove_escaninho';
export const NOVA_GARAGEM = 'nova_garagem';
export const ATUALIZA_GARAGEM = 'atualiza_garagem';
export const REMOVE_GARAGEM = 'remove_garagem';

// Categoria
export const INICIA_CATEGORIA = 'inicia_categoria';
export const SALVA_CATEGORIA = 'salva_categoria';
export const REMOVE_CATEGORIA = 'remove_categoria';
export const NOVO_CATEGORIA = 'novo_categoria';
export const BUSCA_CATEGORIA_EDICAO = 'busca_categoria_edicao';
export const INICIO_CATEGORIA_SUCESSO = 'inicio_categoria_sucesso';
export const SALVA_CATEGORIA_SUCESSO = 'salva_categoria_success';
export const REMOVE_CATEGORIA_SUCESSO = 'remove_categoria_success';
export const BUSCA_CATEGORIA_EDICAO_SUCESSO = 'busca_categoria_edicao_sucesso';
export const LISTA_CATEGORIA_SUCESSO = 'lista_categoria_sucesso';
export const LIMPAR_CATEGORIA = 'limpar_categoria';
export const LISTA_CATEGORIA = 'lista_categoria';
export const INICIO_CENARIO_CATEGORIA_LOCAL = 'inicio_cenario_categoria_local';
export const INICIO_CENARIO_CATEGORIA_LOCAL_SUCESSO = 'inicio_cenario_categoria_local_sucesso';

// Ambientes
export const INICIA_AMBIENTE = 'inicia_ambiente';
export const INICIA_GESTAO_ACESSO = 'inicia_gestao_acesso';
export const INICIO_AMBIENTE_SUCESSO = 'inicio_ambiente_sucesso';
export const INICIO_CENARIO_AMBIENTE_LOCAL = 'inicio_cenario_ambiente_local';
export const INICIO_CENARIO_AMBIENTE_LOCAL_SUCESSO = 'inicio_cenario_ambiente_local_sucesso';
export const CLIQUE_BOTAO_TREEVIEW = 'clique_botao_treeview';
export const ADICIONA_PRIMEIRO_AMBIENTE_LOCAL = 'adiciona_primeiro_ambiente_local';
export const CLIQUE_ADICIONA_AMBIENTE_LOCAL = 'clique_adiciona_ambiente_local';
export const CLIQUE_ADICIONA_PONTO_ACESSO = 'clique_adiciona_ponto_acesso';
export const CLIQUE_ADICIONA_SUB_AMBIENTE = 'clique_adiciona_sub_ambiente';
export const ADICIONA_AMBIENTE_LOCAL = 'adiciona_ambiente_local';
export const ADICIONA_PONTO_ACESSO = 'adiciona_ponto_acesso';
export const ADICIONA_SUB_AMBIENTE = 'adiciona_sub_ambiente';
export const SALVA_AMBIENTES = 'salva_ambientes';
export const SALVA_AMBIENTES_SUCESSO = 'salva_ambientes_sucesso';
export const SALVA_GESTAO_ACESSO = 'salva_gestao_Acesso';
export const SALVA_GESTAO_ACESSO_SUCESSO = 'salva_gestao_acesso_sucesso';
export const PREENCHE_INFORMACAO_PONTO = 'preenche_informacao_ponto';
export const REMOVE_PONTO_ACESSO_LOCAL = 'remove_ponto_acesso_local';
export const REMOVE_AMBIENTE = 'remove_ambiente';
export const ATUALIZA_INFORMACAO_PONTO = 'atualiza_informacao_ponto';
export const CANCELA_INFORMACAO_PONTO = 'cancela_informacao_ponto';

// Titularidades
export const INICIA_TITULARIDADE = 'inicia_titularidade';
export const SALVA_TITULARIDADE = 'salva_titularidade';
export const REMOVE_TITULARIDADE = 'remove_titularidade';
export const NOVO_TITULARIDADE = 'novo_titularidade';
export const BUSCA_TITULARIDADE_EDICAO = 'busca_titularidade_edicao';
export const INICIO_TITULARIDADE_SUCESSO = 'inicio_titularidade_sucesso';
export const SALVA_TITULARIDADE_SUCESSO = 'salva_titularidade_success';
export const REMOVE_TITULARIDADE_SUCESSO = 'remove_titularidade_success';

// Regras de Avalia├º├úo
export const GET_REGRAS_AVALIACAO = 'get_regras_avaliacao';
export const GET_REGRAS_AVALIACAO_SUCCESS = 'get_regras_avaliacao_success';
export const ADD_REGRAS_AVALIACAO = 'add_regras_avaliacao';
export const ADD_REGRAS_AVALIACAO_SUCCESS = 'add_regras_avaliacao_success';
export const UPDATE_REGRAS_AVALIACAO = 'update_regras_avaliacao';
export const UPDATE_REGRAS_AVALIACAO_SUCCESS = 'update_regras_avaliacao_success';
export const DELETE_REGRAS_AVALIACAO = 'delete_regras_avaliacao';
export const DELETE_REGRAS_AVALIACAO_SUCCESS = 'delete_regras_avaliacao_success';
export const BUSCA_REGRAS_AVALIACAO_EDICAO = 'busca_regras_avaliacao_edicao';
export const BUSCA_REGRAS_AVALIACAO_EDICAO_SUCESSO = 'busca_regras_avaliacao_edicao_sucesso';
export const NOVO_REGRAS_AVALIACAO = 'novo_regras_avaliacao';

export const BUSCA_TITULARIDADE_EDICAO_SUCESSO = 'busca_titularidade_edicao_sucesso';
export const LISTA_TITULARIDADE_SUCESSO = 'lista_titularidade_sucesso';
export const LIMPAR_TITULARIDADE = 'limpar_titularidade';
export const LISTA_TITULARIDADE = 'lista_titularidade';
export const INICIO_CENARIO_TITULARIDADE_LOCAL = 'inicio_cenario_titularidade_local';
export const INICIO_CENARIO_TITULARIDADE_LOCAL_SUCESSO = 'inicio_cenario_titularidade_sucesso';

// Clientes
export const INICIA_CLIENTE = 'inicia_cliente';
export const SALVA_CLIENTE = 'salva_cliente';
export const REMOVE_CLIENTE = 'remove_cliente';
export const CONSULTA_CEP = 'consulta_cep';
export const NOVO_CLIENTE = 'novo_cliente';
export const BUSCA_CLIENTE_EDICAO = 'busca_cliente_edicao';
export const INICIO_CLIENTE_SUCESSO = 'inicio_cliente_sucesso';
export const SALVA_CLIENTE_SUCESSO = 'salva_cliente_success';
export const REMOVE_CLIENTE_SUCESSO = 'remove_cliente_success';
export const BUSCA_CLIENTE_EDICAO_SUCESSO = 'busca_cliente_edicao_sucesso';
export const CONSULTA_CEP_SUCESSO = 'consulta_cep_sucesso';
export const CONSULTA_CEP_ERRO = 'consulta_cep_erro';
export const LISTA_CLIENTE_SUCESSO = 'lista_cliente_sucesso';
export const LIMPAR_CLIENTE = 'limpar_cliente';
export const LISTA_CLIENTE = 'lista_cliente';
export const SETAR_IMAGEM_CLIENTE = 'setar_imagem_cliente';
export const NOVO_TELEFONE = 'novo_telefone';
export const ATUALIZA_TELEFONE = 'atualiza_telefone';
export const REMOVE_TELEFONE = 'remove_telefone';
export const NOVO_EMAIL = 'novo_email';
export const ATUALIZA_EMAIL = 'atualiza_email';
export const REMOVE_EMAIL = 'remove_email';
export const CLIQUE_CONTROLE_ABA_CLIENTE = 'clique_controle_aba_local';

// Locais Controlados
export const INICIA_LOCAL_CONTROLADO = 'inicia_local_controlado';
export const SALVA_LOCAL_CONTROLADO = 'salva_local_controlado';
export const REMOVE_LOCAL_CONTROLADO = 'remove_local_controlado';
export const NOVO_LOCAL_CONTROLADO = 'novo_local_controlado';
export const BUSCA_LOCAL_CONTROLADO_EDICAO = 'busca_local_controlado_edicao';
export const INICIO_LOCAL_CONTROLADO_SUCESSO = 'inicio_local_controlado_sucesso';
export const SALVA_LOCAL_CONTROLADO_SUCESSO = 'salva_local_controlado_success';
export const REMOVE_LOCAL_CONTROLADO_SUCESSO = 'remove_local_controlado_success';
export const BUSCA_LOCAL_CONTROLADO_EDICAO_SUCESSO = 'busca_local_controlado_edicao_sucesso';
export const ADICIONA_AMBIENTE_LISTA_VINCULADA = 'adiciona_ambiente_lista_vinculada';
export const REMOVE_AMBIENTE_LISTA_VINCULADA = 'remove_ambiente_lista_vinculada';
export const LISTA_LOCAL_CONTROLADO_SUCESSO = 'lista_local_controlado_sucesso';
export const LIMPAR_LOCAL_CONTROLADO = 'limpar_local_controlado';
export const LISTA_LOCAL_CONTROLADO = 'lista_local_controlado';
export const SETAR_IMAGEM_LOCAL_CONTROLADO = 'setar_imagem_local_controlado';
export const REMOVE_RESPONSABILIDADE = 'remove_responsabilidade';
export const ADICIONA_RESPONSABILIDADE = 'adiciona_responsabilidade';
export const ATUALIZA_RESPONSABILIDADE = 'atualiza_responsabilidade';
export const ATUALIZAR_PERFIL_AUTORIZADO_LOCAL = 'atualizar_perfil_autorizado_local';

// Pontos de Acesso
export const INICIA_PONTO_ACESSO = 'inicia_ponto_acesso';
export const SALVA_PONTO_ACESSO = 'salva_ponto_acesso';
export const REMOVE_PONTO_ACESSO = 'remove_ponto_acesso';
export const LISTA_PONTO_ACESSO = 'lista_ponto_acesso';
export const NOVO_PONTO_ACESSO = 'novo_ponto_acesso';
export const BUSCA_PONTO_ACESSO_EDICAO = 'busca_ponto_acesso_edicao';
export const INICIO_PONTO_ACESSO_SUCESSO = 'inicio_ponto_acesso_sucesso';
export const SALVA_PONTO_ACESSO_SUCESSO = 'salva_ponto_acesso_success';
export const REMOVE_PONTO_ACESSO_SUCESSO = 'remove_ponto_acesso_success';
export const BUSCA_PONTO_ACESSO_EDICAO_SUCESSO = 'busca_ponto_acesso_edicao_sucesso';
export const LISTA_LOCAIS_POR_CLIENTE_PONTO_ACESSO = 'lista_locais_por_cliente_ponto_acesso';
export const LISTA_LOCAIS_SUCESSO = 'lista_locais_sucesso';
export const LISTA_AMBIENTES_POR_LOCAL = 'lista_ambientes_por_local';
export const LISTA_AMBIENTES_PONTOS_POR_LOCAL = 'lista_ambientes_pontos_por_local';
export const LISTA_AMBIENTES_SUCESSO = 'lista_ambientes_sucesso';
export const LISTA_PONTO_ACESSO_SUCESSO = 'lista_ponto_acesso_sucesso';
export const LIMPAR_PONTO_ACESSO = 'limpar_ponto_acesso';
export const LISTA_LOCAIS_SUCESSO_PONTO_ACESSO = 'lsita_locais_sucesso_ponto_acesso';

// Perfis de acesso f├¡sico
export const INICIA_PERFIL = 'inicia_perfil';
export const SALVA_PERFIL = 'salva_perfil';
export const REMOVE_EVENTO_PESSOA_PERFIL = "remove_evento_pessoa_perfil";
export const REMOVE_PERFIL = 'remove_perfil';
export const NOVO_PERFIL = 'novo_perfil';
export const BUSCA_PERFIL_EDICAO = 'busca_perfil_edicao';
export const INICIO_PERFIL_SUCESSO = 'inicio_perfil_sucesso';
export const SALVA_PERFIL_SUCESSO = 'salva_perfil_success';
export const REMOVE_PERFIL_SUCESSO = 'remove_perfil_success';
export const BUSCA_PERFIL_EDICAO_SUCESSO = 'busca_perfil_edicao_sucesso';
export const LISTA_PERFIL_SUCESSO = 'lista_perfil_sucesso';
export const LIMPAR_PERFIL = 'limpar_perfil';
export const LISTA_PERFIL = 'lista_perfil';
export const BUSCA_PESSOA_BASE_UZER_USUARIO_PORTAL = 'busca_pessoa_base_uzer_usuario_portal';
export const EXIBE_DETALHE_ESTRUTURA_LOCAL_PERFIL = 'exibe_detalhe_estrutura_local_perfil';
export const EXIBE_ESTRUTURA_LOCAL_PERFIL = 'exibe_estrutura_local_perfil';
export const EXIBE_DETALHE_ESTRUTURA_LOCAL_PERFIL_SUCESSO = 'exibe_detalhe_estrutura_local_perfil_sucesso';
export const ATUALIZA_AMBIENTE_ORIGEM = 'atualiza_ambiente_origem';

// Perfis do Portal
export const INICIA_PERFIL_PORTAL = 'inicia_perfil_portal';
export const SALVA_PERFIL_PORTAL = 'salva_perfil_portal';
export const REMOVE_PERFIL_PORTAL = 'remove_perfil_portal';
export const NOVO_PERFIL_PORTAL = 'novo_perfil_portal';
export const BUSCA_PERFIL_PORTAL_EDICAO = 'busca_perfil_portal_edicao';
export const INICIO_PERFIL_PORTAL_SUCESSO = 'inicio_perfil_portal_sucesso';
export const SALVA_PERFIL_PORTAL_SUCESSO = 'salva_perfil_portal_success';
export const REMOVE_PERFIL_PORTAL_SUCESSO = 'remove_perfil_portal_success';
export const BUSCA_PERFIL_PORTAL_EDICAO_SUCESSO = 'busca_perfil_portal_edicao_sucesso';
export const LISTA_PERFIL_PORTAL_SUCESSO = 'lista_perfil_portal_sucesso';
export const LIMPAR_PERFIL_PORTAL = 'limpar_perfil_portal';
export const LISTA_PERFIL_PORTAL = 'lista_perfil_portal';
export const ATUALIZAR_PONTO_REQUISICAO = 'atualizar_ponto_requisicao';
export const ATUALIZAR_PERMISSAO_FUNCIONALIDADE = 'atualizar_permissao_funcionalidade';
export const SELECIONAR_TUDO_FUNCIONALIDADE_PERFIL = 'selecionar_tudo_funcionalidade_perfil';
export const SELECIONAR_TUDO_PORTARIA_PERFIL = 'selecionar_tudo_portaria_perfil';
export const ALTERACAO_CHECK_PERFIL = 'alteracao_check_perfil';

// Usu├írios da Plataforma (Pessoas)
export const INICIA_USUARIO_PLATAFORMA_FILTRADO = 'inicia_usuario_plataforma_filtrado';
export const INICIA_USUARIO_PLATAFORMA_FILTRADO_SUCESSO = 'inicia_usuario_plataforma_filtrado_sucesso';

export const INICIA_USUARIOS_ESCOLA = 'inicia_usuarios_escola';
export const INICIA_USUARIOS_ESCOLA_SUCESSO = 'inicia_usuarios_escola_sucesso';
export const INICIA_USUARIOS_ESCOLA_FILTRADO = 'inicia_usuarios_escola_filtrado';
export const INICIA_USUARIOS_ESCOLA_FILTRADO_SUCESSO = 'inicia_usuarios_escola_filtrado_sucesso';
export const BUSCA_USUARIOS_ESCOLA_EDICAO = 'busca_usuarios_escola_edicao';
export const BUSCA_USUARIOS_ESCOLA_EDICAO_SUCESSO = 'busca_usuarios_escola_edicao_sucesso';

export const INICIA_USUARIO_PLATAFORMA = 'inicia_usuario_plataforma';
export const SALVA_USUARIO_PLATAFORMA = 'salva_usuario_plataforma';
export const SALVA_USUARIO_PLATAFORMA_LITE = 'salva_usuario_plataforma_lite';
export const REMOVE_CLIENTE_PESSOA_PLATAFORMA = 'remove_cliente_pessoa_plataforma';
export const REMOVE_USUARIO_PLATAFORMA = 'remove_usuario_plataforma';
export const NOVO_USUARIO_PLATAFORMA = 'novo_usuario_plataforma';
export const BUSCA_USUARIO_PLATAFORMA_EDICAO = 'busca_usuario_plataforma_edicao';
export const BUSCA_USUARIO_PLATAFORMA_LITE_EDICAO = 'busca_usuario_plataforma_lite_edicao';
export const BUSCA_PESSOA_BASE_UZER = 'busca_pessoa_base_uzer';
export const BUSCA_PESSOA_BASE_UZER_LITE = 'busca_pessoa_base_uzer_lite';
export const INICIO_USUARIO_PLATAFORMA_SUCESSO = 'inicio_usuario_plataforma_sucesso';
export const INICIO_PESSOAS_EVENTO = 'inicio_pessoas_evento';
export const RELATORIO_ACESSO_UNICO_PESSOA = "relatorio_acesso_unico_pessoa";
export const RELATORIO_ACESSO_UNICO_PESSOA_SUCESSO = "relatorio_acesso_unico_pessoa_sucesso"
export const INICIO_PESSOAS_EVENTO_SUCESSO = 'inicio_pessoas_evento_sucesso';
export const SALVA_USUARIO_PLATAFORMA_SUCESSO = 'salva_usuario_plataforma_success';
export const REMOVE_USUARIO_PLATAFORMA_SUCESSO = 'remove_usuario_plataforma_success';
export const REMOVE_EVENTO_PESSOA_PERFIL_SUCESSO = 'remove_evento_pessoa_perfil_success';
export const BUSCA_USUARIO_PLATAFORMA_EDICAO_SUCESSO = 'busca_usuario_plataforma_edicao_sucesso';
export const BUSCA_USUARIO_PLATAFORMA_LITE_EDICAO_SUCESSO = 'busca_usuario_plataforma_lite_edicao_sucesso';
export const LISTA_PERFIS_POR_CLIENTE = 'lista_perfis_por_cliente';
export const LISTA_PERFIS_SUCESSO = 'lista_perfis_sucesso';
export const ADICIONA_PERFIL_LISTA_VINCULADA = 'adiciona_perfil_lista_vinculada';
export const REMOVE_PERFIL_LISTA_VINCULADA = 'remove_perfil_lista_vinculada';
export const LISTA_USUARIO_PLATAFORMA_SUCESSO = 'lista_usuario_plataforma_sucesso';
export const LIMPAR_USUARIO_PLATAFORMA = 'limpar_usuario_plataforma';
export const LISTA_USUARIO_PLATAFORMA = 'lista_usuario_plataforma';
export const SETAR_IMAGEM_PESSOA = 'setar_imagem_pessoa';
export const IR_PARA_CADASTRO_PERFIL = 'ir_para_cadastro_perfil';
export const NOVO_TELEFONE_PESSOA = 'novo_telefone_pessoa';
export const NOVO_PERFIL_PESSOA_LITE = 'novo_perfil_pessoa_lite';
export const ATUALIZA_TELEFONE_PESSOA = 'atualiza_telefone_pessoa';
export const ATUALIZA_PERFIL_PESSOA_LITE = 'atualiza_perfil_pessoa_lite';
export const REMOVE_PERFIL_PESSOA_LITE = 'remove_perfil_pessoa_lite';
export const REMOVE_TELEFONE_PESSOA = 'remove_telefone_pessoa';
export const NOVO_EMAIL_PESSOA = 'novo_email_pessoa';
export const ATUALIZA_EMAIL_PESSOA = 'atualiza_email_pessoa';
export const NOVO_COMPLEMENTO = 'novo_complemento';
export const ATUALIZA_COMPLEMENTO = 'atualiza_complemento';
export const REMOVE_COMPLEMENTO = 'remove_complemento';
export const REMOVE_EMAIL_PESSOA = 'remove_email_pessoa';
export const ALTERA_STATUS_PESSOA = 'altera_status_pessoa';
export const CLIQUE_CONTROLE_ABA_USUARIO_PLATAFORMA = 'clique_controle_aba_usuario_plataforma';
export const ALTERA_STATUS_PESSOA_LOCAL = 'altera_status_pessoa_local';
export const EXIBE_ESTRUTURA_LOCAL = 'exibe_estrutura_local';
export const EXIBE_DETALHE_ESTRUTURA_LOCAL = 'exibe_detalhe_estrutura_local';
export const EXIBE_DETALHE_ESTRUTURA_LOCAL_SUCESSO = 'exibe_detalhe_estrutura_local_sucesso';
export const GET_COMPONENTES_SERIE_PADRAO = 'get_componentes_serie_padrao';
export const GET_COMPONENTES_SERIE_PADRAO_SUCESSO = 'get_componentes_serie_padrao_sucesso';

export const ADICIONA_VINCULO_PESSOA = 'adiciona_vinculo_pessoa';
export const REMOVER_VINCULO_PESSOA = 'remover_vinculo_pessoa';
export const ATUALIZAR_VINCULO_PESSOA = 'atualizar_vinculo_pessoa';
export const ATUALIZAR_AMBIENTE_PESSOA = 'atualizar_ambiente_pessoa';
export const ATIVA_CAPTURA_IMAGEM = 'ativa_captura_imagem';
export const CANCELA_CAPTURA_IMAGEM = 'cancela_captura_imagem';
export const OBTEM_IMAGEM_ARRAY_PESSOAS = 'obtem_imagem_array_pessoas';
export const OBTEM_IMAGEM_ARRAY_PESSOAS_SUCESSO = 'obtem_imagem_array_pessoas_sucesso';
export const ENVIAR_SMS_PESSOA_EVENTO = 'enviar_sms_pessoa_evento';
export const ENVIAR_SMS_PESSOA_EVENTO_SUCESSO = 'enviar_sms_pessoa_evento_sucesso';
// Usu├írios do Portal
export const INICIA_USUARIO_PORTAL = 'inicia_usuario_portal';
export const SALVA_USUARIO_PORTAL = 'salva_usuario_portal';
export const REMOVE_USUARIO_PORTAL = 'remove_usuario_portal';
export const NOVO_USUARIO_PORTAL = 'novo_usuario_portal';
export const BUSCA_USUARIO_PORTAL_EDICAO = 'busca_usuario_portal_edicao';
export const INICIO_USUARIO_PORTAL_SUCESSO = 'inicio_usuario_portal_sucesso';
export const SALVA_USUARIO_PORTAL_SUCESSO = 'salva_usuario_portal_success';
export const REMOVE_USUARIO_PORTAL_SUCESSO = 'remove_usuario_portal_success';
export const BUSCA_USUARIO_PORTAL_EDICAO_SUCESSO = 'busca_usuario_portal_edicao_sucesso';
export const ADICIONA_PERFIL_PORTAL_LISTA_VINCULADA = 'adiciona_perfil_portal_lista_vinculada';
export const REMOVE_PERFIL_PORTAL_LISTA_VINCULADA = 'remove_perfil_portal_lista_vinculada';
export const LISTA_USUARIO_PORTAL_SUCESSO = 'lista_usuario_portal_sucesso';
export const LIMPAR_USUARIO_PORTAL = 'limpar_usuario_portal';
export const LISTA_USUARIO_PORTAL = 'lista_usuario_portal';
export const SETAR_IMAGEM_PESSOA_USUARIO = 'setar_imagem_pessoa_usuario';
export const ADICIONA_CLIENTE_LISTA_VINCULADA = 'adiciona_cliente_lista_vinculada';
export const REMOVE_CLIENTE_LISTA_VINCULADA = 'remove_cliente_lista_vinculada';
export const EXIBE_PONTOS_REQUISICAO = 'exibe_pontos_requisicao';
export const ATUALIZAR_PONTO_REQUISICAO_USUARIO = 'atualizar_ponto_requisicao_usuario';
export const ATUALIZAR_PERMISSAO_FUNCIONALIDADE_USUARIO = 'atualizar_permissao_funcionalidade_usuario';
export const NOVO_TELEFONE_USUARIO_PORTAL = 'novo_telefone_usuario_portal';
export const ATUALIZA_TELEFONE_USUARIO_PORTAL = 'atualiza_telefone_usuario_portal';
export const REMOVE_TELEFONE_USUARIO_PORTAL = 'remove_telefone_usuario_portal';

// Rematr├¡cula - Sequ├¬ncia de Enturma├º├úo
export const VERIFICA_SEQUENCIA_ENTURMACAO = 'verifica_sequencia_enturmacao';
export const VERIFICA_SEQUENCIA_ENTURMACAO_SUCESSO = 'verifica_sequencia_enturmacao_sucesso';
export const NOVO_EMAIL_USUARIO_PORTAL = 'novo_email_usuario_portal';
export const ATUALIZA_EMAIL_USUARIO_PORTAL = 'atualiza_email_usuario_portal';
export const REMOVE_EMAIL_USUARIO_PORTAL = 'remove_email_usuario_portal';
export const SETAR_IMAGEM_USUARO = 'setar_imagem_usuario';
export const SELECIONAR_TUDO_FUNCIONALIDADE = 'selecionar_tudo_funcionalidade';
export const SELECIONAR_TUDO_PORTARIA = 'selecionar_tudo_portaria';
export const CLIQUE_CONTROLE_ABA_USUARIO_PORTAL = 'clique_controle_aba_usuario_portal';

// Portaria
export const EXIBE_PONTOS_SELECAO = 'exibe_pontos_selecao';
export const EXIBE_TELA_SELECAO_MODO = 'exibe_tela_selecao_modo';
export const CONFIRMAR_SELECAO_PONTOS = 'confirmar_selecao_pontos';
export const ADICIONA_OBSERVACAO_PESSOA_PERFIL = 'adiciona_observacao_pessoa_perfil';
export const ADICIONA_OBSERVACAO_PESSOA_PERFIL_SUCESSO = 'adiciona_observacao_pessoa_perfil_sucesso';
export const ATIVA_DESATIVA_BUSCA_NOTIFICACOES = 'ativa_desativa_busca_notificacoes';
export const INICIA_PORTARIA = 'inicia_portaria';
export const INICIA_PORTARIA_LIBERACAO = 'inicia_portaria_liberacao';
export const INICIA_PORTARIA_LIBERACAO_SUCESSO = 'inicia_portaria_liberacao_sucesso';
export const CARREGA_PESSOAS_PARA_TESTES = 'carrega_pessoas_para_testes';
export const CARREGA_PESSOAS_PARA_TESTES_SUCESSO = 'carrega_pessoas_para_testes_sucesso';
export const SETAR_ID_INTERVAL = 'setar_id_interval';
export const DESOCUPAR_VAGA_GARAGEM = 'desocupar_vaga_garagem';
export const APLICA_ALTERACOES_GARAGENS = 'aplica_alteracoes_garagens';
export const APLICA_ALTERACOES_GARAGENS_SUCESSO = 'aplica_alteracoes_garagens_sucesso';
export const EXIBE_LOTACAO_GARAGENS = 'exibe_lotacao_garagens';
export const EXIBE_LOTACAO_GARAGENS_SUCESSO = 'exibe_lotacao_garagens_sucesso';
export const SELECIONA_PESSOA_SIMULACAO = 'seleciona_pessoa_simulacao';
export const SELECIONA_PESSOA_PORTARIA = 'seleciona_pessoa_portaria';
export const SELECIONA_PESSOA_PORTARIA_SUCESSO = 'seleciona_pessoa_portaria_sucesso';
export const SELECIONA_LIBERACAO_PORTARIA = 'seleciona_liberacao_portaria';
export const EXECUTA_SIMULACAO = 'executa_simulacao';
export const EXECUTA_SIMULACAO_SUCESSO = 'executa_simulacao_sucesso';
export const DECIDIR_ATENDTO_DUPLO_CHECK = 'decidir_atendto_duplo_check';
export const DECIDIR_ATENDTO_DUPLO_CHECK_SUCESSO = 'decidir_atendto_duplo_check_sucesso';
export const ANALISAR_DETALHES_DC = 'analisar_detalhes_dc';
export const SETAR_IMAGEM_LIBERACAO = 'setar_imagem_liberacao';
export const SALVAR_LIBERACAO = 'salvar_liberacao';
export const SINCRONIZAR_LIBERACAO = 'sincronizar_liberacao';
export const SINCRONIZACAO_PESSOA_ERRO = 'sincronizacao_pessoa_erro';
export const CANCELA_CAPTURA_IMAGEM_PORTARIA = 'cancela_captura_imagem_portaria';
export const OBTEM_IMAGEM_ARRAY_PESSOAS_PORTARIA = 'obtem_imagem_array_pessoas_portaria';
export const OBTEM_IMAGEM_ARRAY_PESSOAS_PORTARIA_SUCESSO = 'obtem_imagem_array_pessoas_portaria_sucesso';
export const ENVIA_SOLICITACAO_ABERTURA_TERMINAL = 'envia_solicitacao_abertura_terminal';
export const ENVIA_SOLICITACAO_ABERTURA_TERMINAL_SUCESSO = 'envia_solicitacao_abertura_terminal_sucesso';
export const ENVIA_SOLICITACAO_ABERTURA_TERMINAL_ERRO = 'envia_solicitacao_abertura_terminal_erro';
export const EXIBE_OCULTA_OBSERVACOES_PERFIL_PESSOA = 'exibe_oculta_observacoes_perfil_pessoa';
export const NOVA_LIBERACAO = 'nova_liberacao';
export const VOLTAR_INICIO_PORTARIA = 'voltar_inicio_portaria';
export const BUSCA_PESSOA_CADASTRADA_LIBERACAO = 'busca_pessoa_cadastrada_liberacao';
export const BUSCA_PESSOA_CADASTRADA_LIBERACAO_SUCESSO = 'busca_pessoa_cadastrada_liberacao_sucesso';
export const FECHAR_PESSOA_EXISTENTE_LIBERACAO = 'fechar_pessoa_existente_liberacao';
export const ALTERA_PERIODO_VALIDADE_LIBERACAO = 'altera_periodo_validade_liberacao';
export const ALTERA_PERIODO_DIA_SEMANA_LIBERACAO = 'altera_periodo_dia_semana_liberacao';
export const ALTERA_DIA_SEMANA_GERAL = 'altera_dia_semana_geral';
export const ALTERA_PERIODO_HORARIO_LIBERACAO = 'altera_periodo_horario_liberacao';
export const ATUALIZA_HORARIO_LIBERACAO = 'atualiza_horario_liberacao';
export const SALVA_LIBERACAO_SUCESSO = 'salva_liberacao_sucesso';
export const ALTERA_VALOR_CHECK_LIBERACAO = 'altera_valor_check_liberacao';
export const EXIBE_MENSAGEM_ERRO_PORTARIA = 'exibe_mensagem_erro_portaria';
export const OCULTA_MENSAGEM_PORTARIA = 'oculta_mensagem_portaria';
export const CAPTURA_IMAGEM_LIBERACAO = 'captura_imagem_liberacao';
export const BUSCA_SOLICITACAO = 'busca_solicitacao';
export const BUSCA_SOLICITACAO_SUCESSO = 'busca_solicitacao_sucesso';
export const BUSCA_FILA_POSICAO = 'busca_fila_posicao';
export const BUSCA_FILA_POSICAO_SUCESSO = 'busca_fila_posicao_sucesso';
export const ATUALIZAR_PONTO_REQUISICAO_PORTEIRO = 'atualizar_ponto_requisicao_porteiro';
export const ATUALIZA_MODO_PORTARIA = 'atualiza_modo_portaria';
export const ATUALIZA_MODO_PORTARIA_SUCESSO = 'atualiza_modo_portaria_sucesso';

// Concess├úo de Acessos (Pessoas)
export const INICIA_ACESSO_PESSOA = 'inicia_acesso_pessoa';
export const SALVA_ACESSO_PESSOA = 'salva_acesso_pessoa';
export const REMOVE_ACESSO_PESSOA = 'remove_acesso_pessoa';
export const NOVO_ACESSO_PESSOA = 'novo_acesso_pessoa';
export const BUSCA_ACESSO_PESSOA_EDICAO = 'busca_acesso_pessoa_edicao';
export const INICIO_ACESSO_PESSOA_SUCESSO = 'inicio_acesso_pessoa_sucesso';
export const SALVA_ACESSO_PESSOA_SUCESSO = 'salva_acesso_pessoa_success';
export const REMOVE_ACESSO_PESSOA_SUCESSO = 'remove_acesso_pessoa_success';
export const BUSCA_ACESSO_PESSOA_EDICAO_SUCESSO = 'busca_acesso_pessoa_edicao_sucesso';
export const LISTA_CONFIGURACAO_PONTO_PESSOA = 'lista_configuracao_ponto_pessoa';
export const LISTA_CONFIGURACAO_PONTO_PESSOA_SUCESSO = 'lista_configuracao_ponto_pessoa_sucesso';
export const ALTERACAO_CHECK_PONTO_ACESSO_PESSOA = 'alteracao_check_ponto_acesso_pessoa';
export const LISTA_ACESSO_PESSOA_SUCESSO = 'lista_acesso_pessoa_sucesso';
export const LIMPAR_ACESSO_PESSOA = 'limpar_acesso_pessoa';
export const LISTA_ACESSO_PESSOA = 'lista_acesso_pessoa';
export const LISTA_LOCAIS_POR_CLIENTE_ACESSO_PESSOA = 'lista_locais_por_cliente_acesso_pessoa';
export const LISTA_LOCAIS_SUCESSO_ACESSO_PESSOA = 'lista_locais_sucesso_acesso_pessoa';

// Concess├úo de Acessos (Acesso Full)
export const INICIA_ACESSO_FULL = 'inicia_acesso_full';
export const SALVA_ACESSO_FULL = 'salva_acesso_full';
export const REMOVE_ACESSO_FULL = 'remove_acesso_full';
export const NOVO_ACESSO_FULL = 'novo_acesso_full';
export const BUSCA_ACESSO_FULL_EDICAO = 'busca_acesso_full_edicao';
export const INICIO_ACESSO_FULL_SUCESSO = 'inicio_acesso_full_sucesso';
export const SALVA_ACESSO_FULL_SUCESSO = 'salva_acesso_full_success';
export const REMOVE_ACESSO_FULL_SUCESSO = 'remove_acesso_full_success';
export const BUSCA_ACESSO_FULL_EDICAO_SUCESSO = 'busca_acesso_full_edicao_sucesso';
export const LISTA_CONFIGURACAO_PONTO_FULL = 'lista_configuracao_ponto_full';
export const LISTA_CONFIGURACAO_PONTO_FULL_SUCESSO = 'lista_configuracao_ponto_full_sucesso';
export const ALTERACAO_CHECK_PONTO_ACESSO_FULL = 'alteracao_check_ponto_acesso_full';
export const LISTA_ACESSO_FULL_SUCESSO = 'lista_acesso_full_sucesso';
export const LIMPAR_ACESSO_FULL = 'limpar_acesso_full';
export const LISTA_ACESSO_FULL = 'lista_acesso_full';
export const LISTA_LOCAIS_POR_CLIENTE_ACESSO_FULL = 'lista_locais_por_cliente_acesso_full';
export const LISTA_LOCAIS_SUCESSO_ACESSO_FULL = 'lista_locais_sucesso_acesso_full';
export const CONSULTA_CPF_SUCESSO_FULL = 'consulta_cpf_sucesso_full';

// Concess├úo de Acessos (Acesso Bloqueado)
export const INICIA_ACESSO_BLOQUEIO = 'inicia_acesso_bloqueio';
export const SALVA_ACESSO_BLOQUEIO = 'salva_acesso_bloqueio';
export const REMOVE_ACESSO_BLOQUEIO = 'remove_acesso_bloqueio';
export const NOVO_ACESSO_BLOQUEIO = 'novo_acesso_bloqueio';
export const BUSCA_ACESSO_BLOQUEIO_EDICAO = 'busca_acesso_bloqueio_edicao';
export const INICIO_ACESSO_BLOQUEIO_SUCESSO = 'inicio_acesso_bloqueio_sucesso';
export const SALVA_ACESSO_BLOQUEIO_SUCESSO = 'salva_acesso_bloqueio_success';
export const REMOVE_ACESSO_BLOQUEIO_SUCESSO = 'remove_acesso_bloqueio_success';
export const BUSCA_ACESSO_BLOQUEIO_EDICAO_SUCESSO = 'busca_acesso_bloqueio_edicao_sucesso';
export const LISTA_CONFIGURACAO_PONTO_BLOQUEIO = 'lista_configuracao_ponto_bloqueio';
export const LISTA_CONFIGURACAO_PONTO_BLOQUEIO_SUCESSO = 'lista_configuracao_ponto_bloqueio_sucesso';
export const ALTERACAO_CHECK_PONTO_ACESSO_BLOQUEIO = 'alteracao_check_ponto_acesso_bloqueio';
export const LISTA_ACESSO_BLOQUEIO_SUCESSO = 'lista_acesso_bloqueio_sucesso';
export const LIMPAR_ACESSO_BLOQUEIO = 'limpar_acesso_bloqueio';
export const LISTA_ACESSO_BLOQUEIO = 'lista_acesso_bloqueio';
export const LISTA_LOCAIS_POR_CLIENTE_ACESSO_BLOQUEIO = 'lista_locais_por_cliente_acesso_bloqueio';
export const LISTA_LOCAIS_SUCESSO_ACESSO_BLOQUEIO = 'lista_locais_sucesso_acesso_bloqueio';
export const CONSULTA_CPF_SUCESSO_BLOQUEIO = 'consulta_cpf_sucesso_bloqueio';

// Concess├úo de Acessos (Perfis)
export const INICIA_ACESSO_PERFIL = 'inicia_acesso_perfil';
export const SALVA_ACESSO_PERFIL = 'salva_acesso_perfil';
export const REMOVE_ACESSO_PERFIL = 'remove_acesso_perfil';
export const NOVO_ACESSO_PERFIL = 'novo_acesso_perfil';
export const BUSCA_ACESSO_PERFIL_EDICAO = 'busca_acesso_perfil_edicao';
export const INICIO_ACESSO_PERFIL_SUCESSO = 'inicio_acesso_perfil_sucesso';
export const SALVA_ACESSO_PERFIL_SUCESSO = 'salva_acesso_perfil_success';
export const REMOVE_ACESSO_PERFIL_SUCESSO = 'remove_acesso_perfil_success';
export const BUSCA_ACESSO_PERFIL_EDICAO_SUCESSO = 'busca_acesso_perfil_edicao_sucesso';
export const LISTA_LOCAIS_PERFIS_POR_CLIENTE = 'lista_locais_perfis_por_cliente';
export const LISTA_LOCAIS_PERFIS_SUCESSO = 'lista_locais_perfis_sucesso';
export const LISTA_CONFIGURACAO_PONTO_PERFIL = 'lista_configuracao_ponto_perfil';
export const LISTA_CONFIGURACAO_PONTO_PERFIL_SUCESSO = 'lista_configuracao_ponto_perfil_sucesso';
export const LISTA_ACESSO_PERFIL_SUCESSO = 'lista_acesso_perfil_sucesso';
export const LIMPAR_ACESSO_PERFIL = 'limpar_acesso_perfil';
export const LISTA_ACESSO_PERFIL = 'lista_acesso_perfil';
export const ALTERACAO_CHECK_PONTO_ACESSO_PERFIL = 'alteracao_check_ponto_acesso_perfil'

// Concess├úo de Acessos (Genero)
export const INICIA_ACESSO_GENERO = 'inicia_acesso_genero';
export const SALVA_ACESSO_GENERO = 'salva_acesso_genero';
export const REMOVE_ACESSO_GENERO = 'remove_acesso_genero';
export const NOVO_ACESSO_GENERO = 'novo_acesso_genero';
export const BUSCA_ACESSO_GENERO_EDICAO = 'busca_acesso_genero_edicao';
export const INICIO_ACESSO_GENERO_SUCESSO = 'inicio_acesso_genero_sucesso';
export const SALVA_ACESSO_GENERO_SUCESSO = 'salva_acesso_genero_success';
export const REMOVE_ACESSO_GENERO_SUCESSO = 'remove_acesso_genero_success';
export const BUSCA_ACESSO_GENERO_EDICAO_SUCESSO = 'busca_acesso_genero_edicao_sucesso';
export const LISTA_CONFIGURACAO_PONTO_GENERO = 'lista_configuracao_ponto_genero';
export const LISTA_CONFIGURACAO_PONTO_GENERO_SUCESSO = 'lista_configuracao_ponto_genero_sucesso';
export const LISTA_ACESSO_GENERO_SUCESSO = 'lista_acesso_genero_sucesso';
export const LIMPAR_ACESSO_GENERO = 'limpar_acesso_genero';
export const LISTA_ACESSO_GENERO = 'lista_acesso_genero';
export const LISTA_LOCAIS_POR_CLIENTE_GENERO = 'lista_locais_por_cliente_genero';
export const ALTERACAO_CHECK_PONTO_ACESSO_GENERO = 'alteracao_check_ponto_acesso_genero';
export const ADICIONA_PERFIL_LISTA_VINCULADA_GENERO = 'adiciona_prefil_lista_vinculada_genero';
export const REMOVE_PERFIL_LISTA_VINCULADA_GENERO = 'remove_perfil_lista_vinculada_genero';

// Concess├úo de Acessos (Idade)
export const INICIA_ACESSO_IDADE = 'inicia_acesso_idade';
export const SALVA_ACESSO_IDADE = 'salva_acesso_idade';
export const REMOVE_ACESSO_IDADE = 'remove_acesso_idade';
export const NOVO_ACESSO_IDADE = 'novo_acesso_idade';
export const BUSCA_ACESSO_IDADE_EDICAO = 'busca_acesso_idade_edicao';
export const INICIO_ACESSO_IDADE_SUCESSO = 'inicio_acesso_idade_sucesso';
export const SALVA_ACESSO_IDADE_SUCESSO = 'salva_acesso_idade_success';
export const REMOVE_ACESSO_IDADE_SUCESSO = 'remove_acesso_idade_success';
export const BUSCA_ACESSO_IDADE_EDICAO_SUCESSO = 'busca_acesso_idade_edicao_sucesso';
export const LISTA_CONFIGURACAO_PONTO_IDADE = 'lista_configuracao_ponto_idade';
export const LISTA_CONFIGURACAO_PONTO_IDADE_SUCESSO = 'lista_configuracao_ponto_idade_sucesso';
export const LISTA_ACESSO_IDADE_SUCESSO = 'lista_acesso_idade_sucesso';
export const LIMPAR_ACESSO_IDADE = 'limpar_acesso_idade';
export const LISTA_ACESSO_IDADE = 'lista_acesso_idade';
export const LISTA_LOCAIS_POR_CLIENTE_IDADE = 'lista_locais_por_cliente_idade';
export const ALTERACAO_CHECK_PONTO_ACESSO_IDADE = 'alteracao_check_ponto_acesso_idade';
export const ADICIONA_PERFIL_LISTA_VINCULADA_IDADE = 'adiciona_perfil_lista_vinculada_idade';
export const REMOVE_PERFIL_LISTA_VINCULADA_IDADE = 'remove_perfil_lista_vinculada_idade';

// Concess├úo de Acessos (Periodo)
export const INICIA_ACESSO_PERIODO = 'inicia_acesso_periodo';
export const SALVA_ACESSO_PERIODO = 'salva_acesso_periodo';
export const REMOVE_ACESSO_PERIODO = 'remove_acesso_periodo';
export const NOVO_ACESSO_PERIODO = 'novo_acesso_periodo';
export const BUSCA_ACESSO_PERIODO_EDICAO = 'busca_acesso_periodo_edicao';
export const INICIO_ACESSO_PERIODO_SUCESSO = 'inicio_acesso_periodo_sucesso';
export const SALVA_ACESSO_PERIODO_SUCESSO = 'salva_acesso_periodo_success';
export const REMOVE_ACESSO_PERIODO_SUCESSO = 'remove_acesso_periodo_success';
export const BUSCA_ACESSO_PERIODO_EDICAO_SUCESSO = 'busca_acesso_periodo_edicao_sucesso';
export const LISTA_CONFIGURACAO_PONTO_PERIODO = 'lista_configuracao_ponto_periodo';
export const LISTA_CONFIGURACAO_PONTO_PERIODO_SUCESSO = 'lista_configuracao_ponto_periodo_sucesso';
export const LISTA_ACESSO_PERIODO_SUCESSO = 'lista_acesso_periodo_sucesso';
export const LIMPAR_ACESSO_PERIODO = 'limpar_acesso_periodo';
export const LISTA_ACESSO_PERIODO = 'lista_acesso_periodo';
export const LISTA_LOCAIS_POR_CLIENTE_ACESSO_PERIODO = 'lista_locais_por_cliente_acesso_periodo';
export const ADICIONA_PERFIL_LISTA_VINCULADA_PERIODO = 'adiciona_prefil_lista_vinculada_periodo';
export const REMOVE_PERFIL_LISTA_VINCULADA_PERIODO = 'remove_perfil_lista_vinculada_periodo';

// Localidades
export const INICIA_LOCALIDADE = 'inicia_localidade';
export const SALVA_LOCALIDADE = 'salva_localidade';
export const REMOVE_LOCALIDADE = 'remove_localidade';
export const LISTA_LOCALIDADE = 'lista_localidade';
export const NOVO_LOCALIDADE = 'novo_localidade';
export const BUSCA_LOCALIDADE_EDICAO = 'busca_localidade_edicao';
export const INICIO_LOCALIDADE_SUCESSO = 'inicio_localidade_sucesso';
export const SALVA_LOCALIDADE_SUCESSO = 'salva_localidade_successo';
export const REMOVE_LOCALIDADE_SUCESSO = 'remove_localidade_successo';
export const BUSCA_LOCALIDADE_EDICAO_SUCESSO = 'busca_localidade_edicao_sucesso';
export const LISTA_LOCAIS_POR_CLIENTE_LOCALIDADE = 'lista_locais_por_cliente_localidade';
export const LISTA_LOCAIS_SUCESSO_LOCALIDADE = 'lista_locais_sucesso_localidade';
export const LISTA_LOCALIDADE_SUCESSO = 'lista_localidade_sucesso';
export const LIMPAR_LOCALIDADE = 'limpar_localidade';
export const ADICIONA_DEPARTAMENTO_LISTA_VINCULADA = 'adiciona_departamento_vinculada_periodo';
export const REMOVE_DEPARTAMENTO_LISTA_VINCULADA = 'remove_departamento_vinculada_periodo';
export const ADICIONA_PONTO_ACESSO_LISTA_VINCULADA_PERIODO = 'adiciona_ponto_acesso_lista_vinculada_periodo';
export const REMOVE_PONTO_ACESSO_LISTA_VINCULADA_PERIODO = 'remove_ponto_acesso_lista_vinculada_periodo';
export const LISTA_PONTO_ACESSO_SUCESSO_LOCALIDADE = 'lista_ponto_acesso_sucesso_localidade';
export const LISTA_PONTO_ACESSO_POR_LOCAL = 'lista_ponto_acesso_por_local';
export const ADICIONA_FUNCAO_LISTA_VINCULADA = 'adiciona_funcao_lista_vinculada';
export const REMOVE_FUNCAO_LISTA_VINCULADA = 'remove_funcao_lista_vinculada';
export const ADICIONA_GRUPO_LISTA_VINCULADA = 'adiciona_grupo_lista_vinculada';
export const REMOVE_GRUPO_LISTA_VINCULADA = 'remove_grupo_lista_vinculada';

// Vinculos Pessoa
export const INICIA_VINCULO_PESSOA = 'inicia_vinculo_pessoa';
export const SALVA_VINCULO_PESSOA = 'salva_vinculo_pessoa';
export const REMOVE_VINCULO_PESSOA = 'remove_vinculo_pessoa';
export const LISTA_VINCULO_PESSOA = 'lista_vinculo_pessoa';
export const NOVO_VINCULO_PESSOA = 'novo_vinculo_pessoa';
export const BUSCA_VINCULO_PESSOA_EDICAO = 'busca_vinculo_pessoa_edicao';
export const INICIO_VINCULO_PESSOA_SUCESSO = 'inicio_vinculo_pessoa_sucesso';
export const SALVA_VINCULO_PESSOA_SUCESSO = 'salva_vinculo_pessoa_successo';
export const REMOVE_VINCULO_PESSOA_SUCESSO = 'remove_vinculo_pessoa_successo';
export const BUSCA_VINCULO_PESSOA_EDICAO_SUCESSO = 'busca_vinculo_pessoa_edicao_sucesso';
export const LISTA_LOCAIS_POR_CLIENTE_VINCULO_PESSOA = 'lista_locais_por_cliente_vinculo_pessoa';
export const LISTA_LOCAIS_SUCESSO_VINCULO_PESSOA = 'lista_locais_sucesso_vinculo_pessoa';
export const LISTA_VINCULO_PESSOA_SUCESSO = 'lista_vinculo_pessoa_sucesso';
export const LIMPAR_VINCULO_PESSOA = 'limpar_vinculo_pessoa';
export const ADICIONA_VINCULO_PESSOA_LISTA_VINCULADA = 'adiciona_vinculo_pessoa_lista_vinculada';
export const REMOVE_VINCULO_PESSOA_LISTA_VINCULADA = 'remove_vinculo_pessoa_lista_vinculada';
export const LISTA_LOCALIDADE_POR_LOCAL = 'lista_localidade_por_local';
export const LISTA_LOCALIDADE_POR_LOCAL_SUCESSO = 'lista_localidade_por_local_sucesso';
export const LISTA_DEPARTAMENTO_POR_LOCALIDADE = 'lista_departamento_por_localidade';
export const LISTA_DEPARTAMENTO_POR_LOCALIDADE_SUCESSO = 'lista_departamento_por_localidade_sucesso';
export const CONSULTA_CPF_VINCULO = 'consulta_cpf_vinculo';
export const CONSULTA_CPF_SUCESSO_VINCULO = 'consulta_cpf_sucesso_vinculo';

// Gest├úo de acesso
export const CONSULTA_CPF_ACESSO = 'consulta_cpf_acesso';
export const CONSULTA_CPF_ACESSO_SUCESSO = 'consulta_cpf_acesso_sucesso';
export const OBTER_INFORMACAO_ACESSO_PONTO = 'obter_informacao_acesso_ponto';
export const REMOVE_PESSOA_LOCAL = 'remove_pessoa_local';
export const ADICIONA_PESSOA_LOCAL = 'adiciona_pessoa_local';
export const ADICIONA_PESSOA_LOCAL_SUCESSO = 'adiciona_pessoa_local_sucesso';
export const REMOVE_PERFIL_LOCAL = 'remove_perfil_local';
export const ADICIONA_PERFIL_LOCAL = 'adiciona_perfil_local';
export const ADICIONA_GENERO_LOCAL = 'adiciona_genero_local';
export const REMOVE_GENERO_LOCAL = 'remove_genero_local';
export const ADICIONA_IDADE_LOCAL = 'adiciona_idade_local';
export const REMOVE_IDADE_LOCAL = 'remove_idade_local';
export const CONSULTA_CPF_ACESSO_FULL = 'remove_cpf_acesso_full';
export const CONSULTA_CPF_ACESSO_FULL_SUCESSO = 'remove_cpf_acesso_full_sucesso';
export const ADICIONA_PESSOA_LOCAL_FULL_SUCESSO = 'adiciona_pessoa_local_full_sucesso';
export const ADICIONA_PESSOA_LOCAL_FULL = 'adiciona_acesso_full_local';
export const REMOVE_PESSOA_LOCAL_FULL = 'remove_pessoa_local_full';
export const OBTER_ACESSO_LOCAL_CONTROLADO = 'obter_acesso_local_controlado';
export const OBTER_ACESSO_LOCAL_CONTROLADO_SUCESSO = 'obter_acesso_local_controlado_sucesso';
export const ADICIONA_PESSOA_LOCAL_BLOQUEIO_SUCESSO = 'adiciona_pessoa_local_bloqueio_sucesso';
export const REMOVE_PESSOA_LOCAL_BLOQUEIO = 'remove_pessoa_local_bloqueio';
export const CONSULTA_CPF_ACESSO_BLOQUEIO = 'consulta_cpf_acesso_bloqueio';
export const CONSULTA_CPF_ACESSO_BLOQUEIO_SUCESSO = 'consulta_cpf_acesso_bloqueio_sucesso';
export const ADICIONA_PERIODO_LOCAL = 'adiciona_periodo_local';
export const REMOVE_PERIODO_LOCAL = 'remove_periodo_local';
export const REMOVE_HORARIO_PERIODO = "remove_horario_periodo";
export const EDITA_PERIODO_LOCAL = "edita_periodo_local";
export const CANCELA_PERIODO_LOCAL = "cancela_periodo_local";
export const ALTERACAO_CHECK_TODOS_DIAS_SEMANA = 'alteracao_check_todos_dias_semana';
export const ALTERACAO_CHECK_EM_QUALQUER_HORARIO = 'alteracao_check_qualquer_horario';
export const ALTERACAO_CHECK_INICIO_FIM_PROGRAMADO = 'alteracao_check_inicio_fim_programado';
export const ADICIONA_TODA_BASE_SUCESSO = 'adiciona_toda_base_sucesso';
export const ADICIONA_TODA_BASE_LOCAL = 'adiciona_toda_base_local';
export const ADICIONA_PESSOA_LOCAL_BLOQUEIO = 'adiciona_pessoa_local_bloqueio';
export const ADICIONA_PERFIL_LOCAL_SUCESSO = 'adiciona_perfil_local_sucesso';
export const ADICIONA_GENERO_LOCAL_SUCESSO = 'adiciona_genero_local_sucesso';
export const ADICIONA_IDADE_LOCAL_SUCESSO = 'adiciona_idade_local_sucesso';
export const ADICIONA_PERIODO_LOCAL_SUCESSO = 'adiciona_periodo_local_sucesso';
export const CONSULTA_CPF_PERIODO = 'consulta_cpf_periodo';
export const CONSULTA_CPF_PERIODO_SUCESSO = 'consulta_cpf_periodo_sucesso';
export const NOVO_HORARIO = 'novo_horario';
export const REMOVE_HORARIO = 'remove_horario';
export const ATUALIZA_HORARIO = 'atualiza_horario';

// Rematricula
export const INICIA_REMATRICULA = 'inicia_rematricula';
export const SALVA_REMATRICULA = 'salva_rematricula';
export const SALVA_REMATRICULA_SUCESSO = 'salva_rematricula_sucesso';
export const LIMPAR_REMATRICULA = 'limpar_rematricula';
export const NOVA_REMATRICULA = 'nova_rematricula';
export const LISTA_ESCOLAS_REMATRICULA = 'lista_escolas_rematricula';
export const LISTA_ESCOLAS_REMATRICULA_SUCESSO = 'lista_escolas_rematricula_sucesso';
export const LISTA_CURSOS_REMATRICULA = 'lista_cursos_rematricula';
export const LISTA_CURSOS_REMATRICULA_SUCESSO = 'lista_cursos_rematricula_sucesso';
export const LISTA_SERIES_REMATRICULA = 'lista_series_rematricula';
export const LISTA_SERIES_REMATRICULA_SUCESSO = 'lista_series_rematricula_sucesso';
export const LISTA_TURMAS_ORIGEM_REMATRICULA = 'lista_turmas_origem_rematricula';
export const LISTA_TURMAS_ORIGEM_REMATRICULA_SUCESSO = 'lista_turmas_origem_rematricula_sucesso';
export const LISTA_TURMAS_DESTINO_REMATRICULA = 'lista_turmas_destino_rematricula';
export const LISTA_TURMAS_DESTINO_REMATRICULA_SUCESSO = 'lista_turmas_destino_rematricula_sucesso';
export const LISTA_ANOS_DESTINO_REMATRICULA = 'lista_anos_destino_rematricula';
export const LISTA_ANOS_DESTINO_REMATRICULA_SUCESSO = 'lista_anos_destino_rematricula_sucesso';
export const LISTA_TURMAS_FILTRO_REMATRICULA = 'lista_turmas_filtro_rematricula';
export const LISTA_TURMAS_FILTRO_REMATRICULA_SUCESSO = 'lista_turmas_filtro_rematricula_sucesso';
export const LISTA_REMATRICULA = 'lista_rematricula';
export const LISTA_REMATRICULA_SUCESSO = 'lista_rematricula_sucesso';
export const DETALHE_REMATRICULA = 'detalhe_rematricula';
export const DETALHE_REMATRICULA_SUCESSO = 'detalhe_rematricula_sucesso';
export const FECHAR_DETALHE_REMATRICULA = 'fechar_detalhe_rematricula';

export const ATUALIZA_AMBIENTE_PORTARIA = 'atualiza_ambiente_portaria';
export const ATUALIZA_CONTROLE_GARAGEM = 'atualiza_controle_garagem';
export const EXIBIR_ESTRUTURA_COPIA_ACESSOS = 'exibir_estrutura_copia_acessos';

// Portaria Inicio

export const INICIA_PESSOAS = 'inicia_pessoas';
export const INICIA_LIBERACOES = 'inicia_liberacoes';
export const ALTERACAO_CAMPO_PORTARIA = 'alteracao_campo_portaria';
export const FECHA_MODULOS_PORTARIA = 'fecha_modulos_portaria';
export const SELECIONA_MODULOS_PORTARIA = 'seleciona_modulos_portaria';
export const IR_PARA_MODULO = 'ir_para_modulo';
export const INICIA_PORTARIA_SUCESSO = 'inicia_portaria_sucesso';
export const CARREGAR_CONFIGURACAO_INICIAL = 'carregar_configuracao_inicial';

// Sequ├¬ncia de Enturma├º├úo
export const INICIA_SEQUENCIA_ENTURMACAO = 'inicia_sequencia_enturmacao';
export const INICIA_SEQUENCIA_ENTURMACAO_SUCESSO = 'inicia_sequencia_enturmacao_sucesso';
export const SALVA_SEQUENCIA_ENTURMACAO = 'salva_sequencia_enturmacao';
export const SALVA_SEQUENCIA_ENTURMACAO_SUCESSO = 'salva_sequencia_enturmacao_sucesso';
export const REMOVE_SEQUENCIA_ENTURMACAO = 'remove_sequencia_enturmacao';
export const REMOVE_SEQUENCIA_ENTURMACAO_SUCESSO = 'remove_sequencia_enturmacao_sucesso';
export const LISTA_SEQUENCIA_ENTURMACAO = 'lista_sequencia_enturmacao';
export const LISTA_SEQUENCIA_ENTURMACAO_SUCESSO = 'lista_sequencia_enturmacao_sucesso';
export const BUSCA_SEQUENCIA_ENTURMACAO_EDICAO = 'busca_sequencia_enturmacao_edicao';
export const BUSCA_SEQUENCIA_ENTURMACAO_EDICAO_SUCESSO = 'busca_sequencia_enturmacao_edicao_sucesso';
export const LIMPAR_SEQUENCIA_ENTURMACAO = 'limpar_sequencia_enturmacao';
export const NOVO_SEQUENCIA_ENTURMACAO = 'novo_sequencia_enturmacao';

// DashBoard presenca
export const INICIA_DASHBOARD_PRESENCA = 'inicia_dashboard_presenca';
export const INICIA_DASHBOARD_PRESENCA_SUCESSO = 'inicia_dashboard_presenca_sucesso';
export const BUSCA_DASHBOARD_PRESENCA = 'busca_dashboard_presenca';
export const BUSCA_DASHBOARD_PRESENCA_SUCESSO = 'busca_dashboard_presenca_sucesso';

// Alunos / Notifica├º├Áes
export const INICIA_NOTIFICACAO = 'inicia_notificacao';
export const INICIO_NOTIFICACAO_SUCESSO = 'inicia_notificacao_sucesso';
export const SALVA_NOTIFICACAO = 'salva_notificacao';
export const SALVA_NOTIFICACAO_SUCESSO = 'salva_notificacao_success';
export const ATUALIZA_NOTIFICACAO = 'atualiza_notificacao';
export const REMOVE_NOTIFICACAO = 'remove_notificacao';
export const REMOVE_NOTIFICACAO_SUCESSO = 'remove_notificacao_success';
export const NOVO_NOTIFICACAO = 'novo_notificacao';
export const BUSCA_NOTIFICACAO_EDICAO = 'busca_notificacao_edicao';
export const BUSCA_NOTIFICACAO_EDICAO_SUCESSO = 'busca_notificacao_edicao_sucesso';
export const LISTA_NOTIFICACAO = 'lista_notificacao';
export const LISTA_NOTIFICACAO_SUCESSO = 'lista_notificacao_sucesso';
export const LIMPAR_NOTIFICACAO = 'limpar_notificacao';
export const SETAR_IMAGEM_NOTIFICACAO = 'setar_imagem_notificacao';
export const NOTIFICACAO_LISTA_ESCOLAS = 'notificacao_lista_escolas';
export const NOTIFICACAO_LISTA_ESCOLAS_SUCESSO = 'notificacao_lista_escolas_sucesso';
export const NOTIFICACAO_LISTA_CATEGORIAS = 'notificacao_lista_categorias';
export const NOTIFICACAO_LISTA_CATEGORIAS_SUCESSO = 'notificacao_lista_categorias_sucesso';
export const NOTIFICACAO_LISTA_TURMAS = 'notificacao_lista_turmas';
export const NOTIFICACAO_LISTA_TURMAS_SUCESSO = 'notificacao_lista_turmas_sucesso';
export const NOTIFICACAO_ALTERACAO_CHECK = 'notificacao_alteracao_check';
export const NOTIFICACAO_ALTERACAO_DATA = 'notificacao_alteracao_data';
// Comunica├º├úo / Enquetes
export const INICIA_ENQUETES = 'inicia_enquetes';
export const NOVO_ENQUETE = 'novo_enquete';
export const INICIO_ENQUETES_SUCESSO = 'inicia_enquetes_sucesso';
export const SALVA_ENQUETE_LOCAL = 'salva_enquete_local';
export const SALVA_ENQUETE_SUCESSO = 'salva_enquete_sucesso';
export const REMOVE_ENQUETE_LOCAL = 'remove_enquete_local';
export const REMOVE_ENQUETE_SUCESSO = 'remove_enquete_sucesso';
export const LISTA_ENQUETES = 'lista_enquetes';
export const LISTA_ENQUETES_SUCESSO = 'lista_enquetes_sucesso';
export const BUSCA_ENQUETE_EDICAO = 'busca_enquete_edicao';
export const BUSCA_ENQUETE_EDICAO_SUCESSO = 'busca_enquete_edicao_sucesso';
export const ABRE_DASHBOARD_ENQUETE = 'abre_dashboard_enquete';
export const ABRE_DASHBOARD_ENQUETE_SUCESSO = 'abre_dashboard_enquete_sucesso';
export const FECHA_DASHBOARD_ENQUETE = 'fecha_dashboard_enquete';
export const REGISTRA_VOTO_ENQUETE = 'registra_voto_enquete';
export const REGISTRA_VOTO_ENQUETE_SUCESSO = 'registra_voto_enquete_sucesso';
export const CANCELA_EDICAO_ENQUETE = 'cancela_edicao_enquete';
export const LIMPAR_ENQUETE = 'limpar_enquete';
export const ENQUETES_SHOW_MESSAGE = 'enquetes_show_message';
export const ENQUETES_HIDE_MESSAGE = 'enquetes_hide_message';
export const INICIO_RECUPERAR_SENHA = 'inicio_recuperar_senha';
export const INICIO_RECUPERAR_SENHA_SUCESSO = 'inicio_recuperar_senha_sucesso';
export const INICIO_RECUPERAR_SENHA_FALHA = 'inicio_recuperar_senha_falha';
export const RECUPERAR_SENHA = 'recuperar_senha';
export const RECUPERAR_SENHA_SUCESSO = 'recuperar_senha_sucesso';
export const RECUPERAR_SENHA_FALHA = 'recuperar_senha_falha';

// Notas e Faltas
export const INICIA_NOTAS_FALTAS = 'inicia_notas_faltas';
export const INICIO_NOTAS_FALTAS_SUCESSO = 'inicio_notas_faltas_sucesso';
export const BUSCA_NOTAS_FALTAS = 'busca_notas_faltas';
export const BUSCA_NOTAS_FALTAS_SUCESSO = 'busca_notas_faltas_sucesso';
export const LISTA_CURSOS_NOTAS_FALTAS = 'lista_cursos_notas_faltas';
export const LISTA_CURSOS_NOTAS_FALTAS_SUCESSO = 'lista_cursos_notas_faltas_sucesso';
export const LISTA_SERIES_NOTAS_FALTAS = 'lista_series_notas_faltas';
export const LISTA_SERIES_NOTAS_FALTAS_SUCESSO = 'lista_series_notas_faltas_sucesso';
export const LISTA_TURMAS_NOTAS_FALTAS = 'lista_turmas_notas_faltas';
export const LISTA_TURMAS_NOTAS_FALTAS_SUCESSO = 'lista_turmas_notas_faltas_sucesso';
export const LISTA_ETAPAS_NOTAS_FALTAS = 'lista_etapas_notas_faltas';
export const LISTA_ETAPAS_NOTAS_FALTAS_SUCESSO = 'lista_etapas_notas_faltas_sucesso';
export const LISTA_DISCIPLINAS_NOTAS_FALTAS = 'lista_disciplinas_notas_faltas';
export const LISTA_DISCIPLINAS_NOTAS_FALTAS_SUCESSO = 'lista_disciplinas_notas_faltas_sucesso';
export const LISTA_MATRICULAS_NOTAS_FALTAS = 'lista_matriculas_notas_faltas';
export const LISTA_MATRICULAS_NOTAS_FALTAS_SUCESSO = 'lista_matriculas_notas_faltas_sucesso';
export const LIMPAR_NOTAS_FALTAS = 'limpar_notas_faltas';
export const VOLTAR_PARA_FILTROS_NOTAS_FALTAS = 'voltar_para_filtros_notas_faltas';
export const ATUALIZA_NOTA_ALUNO = 'atualiza_nota_aluno';
export const SALVA_NOTA_FALTA = 'salva_nota_falta';
export const SALVA_NOTA_FALTA_SUCESSO = 'salva_nota_falta_sucesso';
export const SALVA_NOTA_FALTA_ERRO = 'salva_nota_falta_erro';
export const SALVA_PARECER_DESCRITIVO = 'salva_parecer_descritivo';
export const SALVA_PARECER_DESCRITIVO_SUCESSO = 'salva_parecer_descritivo_sucesso';
export const SALVA_NOTA_CONSELHO = 'salva_nota_conselho';
export const SALVA_NOTA_CONSELHO_SUCESSO = 'salva_nota_conselho_sucesso';
export const SALVA_NOTA_CONSELHO_ERRO = 'salva_nota_conselho_erro';
export const SALVA_SITUACAO_MATRICULA = 'salva_situacao_matricula';
export const SALVA_SITUACAO_MATRICULA_SUCESSO = 'salva_situacao_matricula_sucesso';
export const SALVA_NOTA_RECUPERACAO = 'salva_nota_recuperacao';
export const SALVA_NOTA_RECUPERACAO_SUCESSO = 'salva_nota_recuperacao_sucesso';

// Justificativa de Falta
export const LISTA_JUSTIFICATIVAS_FALTA = 'lista_justificativas_falta';
export const LISTA_JUSTIFICATIVAS_FALTA_SUCESSO = 'lista_justificativas_falta_sucesso';
export const CRIA_JUSTIFICATIVA_FALTA = 'cria_justificativa_falta';
export const CRIA_JUSTIFICATIVA_FALTA_SUCESSO = 'cria_justificativa_falta_sucesso';
export const EDITA_JUSTIFICATIVA_FALTA = 'edita_justificativa_falta';
export const EDITA_JUSTIFICATIVA_FALTA_SUCESSO = 'edita_justificativa_falta_sucesso';
export const REMOVE_JUSTIFICATIVA_FALTA = 'remove_justificativa_falta';
export const REMOVE_JUSTIFICATIVA_FALTA_SUCESSO = 'remove_justificativa_falta_sucesso';
export const DESVINCULAR_JUSTIFICATIVA_FALTA = 'desvincular_justificativa_falta';
export const DESVINCULAR_JUSTIFICATIVA_FALTA_SUCESSO = 'desvincular_justificativa_falta_sucesso';
export const CALCULO_JUSTIFICATIVA_FALTA = 'calculo_justificativa_falta';
export const CALCULO_JUSTIFICATIVA_FALTA_SUCESSO = 'calculo_justificativa_falta_sucesso';
export const ADICIONA_ANEXOS_JUSTIFICATIVA_FALTA = 'adiciona_anexos_justificativa_falta';
export const ADICIONA_ANEXOS_JUSTIFICATIVA_FALTA_SUCESSO = 'adiciona_anexos_justificativa_falta_sucesso';
export const REMOVE_ANEXO_JUSTIFICATIVA_FALTA = 'remove_anexo_justificativa_falta';
export const REMOVE_ANEXO_JUSTIFICATIVA_FALTA_SUCESSO = 'remove_anexo_justificativa_falta_sucesso';
export const JUSTIFICATIVA_FALTA_ERRO = 'justificativa_falta_erro';
export const LIMPA_CONTEXTO_JUSTIFICATIVA_FALTA = 'limpa_contexto_justificativa_falta';

// Atividades Pedag├│gicas
export const INICIA_ATIVIDADE_PEDAGOGICA = 'inicia_atividade_pedagogica';
export const INICIO_ATIVIDADE_PEDAGOGICA_SUCESSO = 'inicio_atividade_pedagogica_sucesso';
export const LISTA_ATIVIDADE_PEDAGOGICA = 'lista_atividade_pedagogica';
export const LISTA_ATIVIDADE_PEDAGOGICA_SUCESSO = 'lista_atividade_pedagogica_sucesso';
export const SALVA_ATIVIDADE_PEDAGOGICA = 'salva_atividade_pedagogica';
export const SALVA_ATIVIDADE_PEDAGOGICA_SUCESSO = 'salva_atividade_pedagogica_sucesso';
export const REMOVE_ATIVIDADE_PEDAGOGICA = 'remove_atividade_pedagogica';
export const REMOVE_ATIVIDADE_PEDAGOGICA_SUCESSO = 'remove_atividade_pedagogica_sucesso';
export const BUSCA_ATIVIDADE_PEDAGOGICA_EDICAO = 'busca_atividade_pedagogica_edicao';
export const BUSCA_ATIVIDADE_PEDAGOGICA_EDICAO_SUCESSO = 'busca_atividade_pedagogica_edicao_sucesso';
export const NOVA_ATIVIDADE_PEDAGOGICA = 'novo_atividade_pedagogica';
export const ATUALIZA_ATIVIDADE_PEDAGOGICA = 'atualiza_atividade_pedagogica';
export const LIMPAR_ATIVIDADE_PEDAGOGICA = 'limpar_atividade_pedagogica';
export const LISTA_TURMAS_PARA_ATIVIDADE = 'lista_turmas_para_atividade';
export const LISTA_TURMAS_PARA_ATIVIDADE_SUCESSO = 'lista_turmas_para_atividade_sucesso';

// Filtros Cascata Atividades
export const LISTA_ESCOLAS_ATIVIDADE = 'lista_escolas_atividade';
export const LISTA_ESCOLAS_ATIVIDADE_SUCESSO = 'lista_escolas_atividade_sucesso';
export const LISTA_CURSOS_ATIVIDADE = 'lista_cursos_atividade';
export const LISTA_CURSOS_ATIVIDADE_SUCESSO = 'lista_cursos_atividade_sucesso';
export const LISTA_SERIES_ATIVIDADE = 'lista_series_atividade';
export const LISTA_SERIES_ATIVIDADE_SUCESSO = 'lista_series_atividade_sucesso';
export const LISTA_ETAPAS_ATIVIDADE = 'lista_etapas_atividade';
export const LISTA_ETAPAS_ATIVIDADE_SUCESSO = 'lista_etapas_atividade_sucesso';
export const LISTA_DISCIPLINAS_ATIVIDADE = 'lista_disciplinas_atividade';
export const LISTA_DISCIPLINAS_ATIVIDADE_SUCESSO = 'lista_disciplinas_atividade_sucesso';
export const LISTA_ALUNOS_TURMA_ATIVIDADE = 'lista_alunos_turma_atividade';
export const LISTA_ALUNOS_TURMA_ATIVIDADE_SUCESSO = 'lista_alunos_turma_atividade_sucesso';
export const LIMPAR_FILTROS_ATIVIDADE = 'limpar_filtros_atividade';
export const NOVA_ATIVIDADE_PEDAGOGICA_LOTE = 'nova_atividade_pedagogica_lote';
export const SALVA_ATIVIDADE_PEDAGOGICA_LOTE = 'salva_atividade_pedagogica_lote';
export const SALVA_ATIVIDADE_PEDAGOGICA_LOTE_SUCESSO = 'salva_atividade_pedagogica_lote_sucesso';

export const INICIO_CANTINA = 'inicio_cantina';
export const INICIO_CANTINA_SUCESSO = 'inicio_cantina_sucesso';
export const INICIO_CANTINA_FALHA = 'inicio_cantina_falha';
export const BUSCAR_REGISTRO_CANTINA_TURMA = 'buscar_registro_cantina_turma';
export const BUSCAR_REGISTRO_CANTINA_IDADE = 'buscar_registro_cantina_idade';
export const BUSCAR_REGISTRO_CANTINA_TURMA_SUCESSO = 'buscar_registro_cantina_turma_sucesso';
export const BUSCAR_REGISTRO_CANTINA_IDADE_SUCESSO = 'buscar_registro_cantina_idade_sucesso';
export const CANTINA_LISTA_ESCOLAS = 'cantina_lista_escolas';
export const CANTINA_LISTA_ESCOLAS_SUCESSO = 'cantina_lista_escolas_sucesso';
export const BUSCAR_REGISTRO_RESTRICOES = 'buscar_registro_restricoes';
export const BUSCAR_REGISTRO_RESTRICOES_SUCESSO = 'buscar_registro_restricoes_sucesso';
export const SETAR_COMBO_ESCOLA_CANTINA = 'setar_combo_escola_cantina';
// Di├írio Escolar
export const INICIA_DIARIO = 'inicia_diario';
export const INICIO_DIARIO_SUCESSO = 'inicio_diario_sucesso';
export const BUSCA_DIARIO = 'busca_diario';
export const BUSCA_DIARIO_SUCESSO = 'busca_diario_sucesso';
export const LANCA_FALTAS_DIARIO = 'lanca_faltas_diario';
export const LANCA_FALTAS_DIARIO_SUCESSO = 'lanca_faltas_diario_sucesso';
export const LISTA_CURSOS_DIARIO = 'lista_cursos_diario';
export const LISTA_CURSOS_DIARIO_SUCESSO = 'lista_cursos_diario_sucesso';
export const LISTA_SERIES_DIARIO = 'lista_series_diario';
export const LISTA_SERIES_DIARIO_SUCESSO = 'lista_series_diario_sucesso';
export const LISTA_TURMAS_DIARIO = 'lista_turmas_diario';
export const LISTA_TURMAS_DIARIO_SUCESSO = 'lista_turmas_diario_sucesso';
export const LIMPAR_DIARIO = 'limpar_diario';
export const VOLTAR_PARA_FILTROS_DIARIO = 'voltar_para_filtros_diario';
export const TOGGLE_FALTA_DIARIO = 'toggle_falta_diario';
export const REABRIR_DIARIO = 'reabrir_diario';
export const REABRIR_DIARIO_SUCESSO = 'reabrir_diario_sucesso';
export const FECHAR_DIARIO = 'fechar_diario';
export const FECHAR_DIARIO_SUCESSO = 'fechar_diario_sucesso';

// Matrículas - dispensa curricular
export const MATRICULA_DISPENSA_MODAL_OPEN = 'matricula_dispensa_modal_open';
export const MATRICULA_DISPENSA_MODAL_OPEN_SUCESSO = 'matricula_dispensa_modal_open_sucesso';
export const MATRICULA_DISPENSA_MODAL_CLOSE = 'matricula_dispensa_modal_close';
export const MATRICULA_DISPENSA_MODAL_ATUALIZA_CAMPO = 'matricula_dispensa_modal_atualiza_campo';
export const MATRICULA_DISPENSA_SALVAR = 'matricula_dispensa_salvar';
export const MATRICULA_DISPENSA_SALVAR_SUCESSO = 'matricula_dispensa_salvar_sucesso';
export const MATRICULA_DISPENSA_REMOVER = 'matricula_dispensa_remover';
export const MATRICULA_DISPENSA_REMOVER_SUCESSO = 'matricula_dispensa_remover_sucesso';
export const LISTA_TIPOS_DISPENSA = 'lista_tipos_dispensa';
export const LISTA_TIPOS_DISPENSA_SUCESSO = 'lista_tipos_dispensa_sucesso';
export const LISTA_DISPENSAS_MATRICULA = 'lista_dispensas_matricula';
export const LISTA_DISPENSAS_MATRICULA_SUCESSO = 'lista_dispensas_matricula_sucesso';
export const LISTA_COMPONENTES_ESCOLA_DISPENSA = 'lista_componentes_escola_dispensa';
export const LISTA_COMPONENTES_ESCOLA_DISPENSA_SUCESSO = 'lista_componentes_escola_dispensa_sucesso';
export const LISTA_PERIODOS_ANO_LETIVO_DISPENSA = 'lista_periodos_ano_letivo_dispensa';
export const LISTA_PERIODOS_ANO_LETIVO_DISPENSA_SUCESSO = 'lista_periodos_ano_letivo_dispensa_sucesso';
export const MATRICULA_DISPENSA_BUSCA_MATRICULA_SUCESSO = 'matricula_dispensa_busca_matricula_sucesso';
export const SETAR_IMAGEM_ENQUETE = 'setar_imagem_enquete';
